/* eslint-disable no-useless-escape */
import { IconButton } from "@material-ui/core"
import DeleteIcon from "@material-ui/icons/Delete"
import { IconTrash } from "@tabler/icons-react"
import { useCallback, useId, useMemo, useRef, useState } from "react"
import styled from "styled-components"
import tinyColor2 from "tinycolor2"
import { useDeepCompareMemo } from "../../../../../../../../utils/use-deep-compare"
import { apxTheme } from "../../../../../../../ApplicationFrame/styling/CustomCSS"
import DotCarousel from "../../../../../../../ReusableComponents/Carousel/Carousel"
import ThemedTooltip from "../../../../../../../ReusableComponents/ThemedTooltip"
import { sendEvent } from "../../../../../../common/ApxEventHandler"
import {
  ACTION_CLASSES,
  DEFAULT_MSG_MARGIN,
  HIDE_CONFIGURATION_TOOLBARS,
  INAPP_LAYOUT_TYPES,
  INITIAL_ONBOARDING_STATE,
  MODAL_NEW_BUTTONS_ROW_NAMES,
  MODULE_TYPES,
  NEW_CONFIG_BACKGROUND_COACHMARK_DELTA_CIRCLE,
  NEW_CONFIG_BACKGROUND_COACHMARK_DELTA_RECT,
  NEW_CONFIG_ELEMENT_HIGHLIGHTER_DELTA_CIRCLE,
  NEW_CONFIG_ELEMENT_HIGHLIGHTER_DELTA_RECT,
  NEW_CONFIG_SET_BACKGROUND_COLOR,
  NEW_CONFIG_SET_BACKGROUND_OFFSET,
  NEW_CONFIG_SET_BACKGROUND_OPACITY,
  NEXT_BUTTON_STATE,
  PREV_BUTTON_STATE,
  SET_ADAPTIVE_TEXT,
  SET_ARROW_COLOR,
  SET_BACKGROUND_COLOR,
  SET_BACKGROUND_OFFSET_DISTANCE,
  SET_BACKGROUND_OFFSET_SKID,
  SET_BACKGROUND_POSITION_OFFSET_DISTANCE,
  SET_BACKGROUND_POSITION_OFFSET_SKID,
  SET_BG_IMAGE,
  SET_BG_IMAGE_SIZE,
  SET_BORDER_BOTTOM_RADIUS,
  SET_BORDER_RADIUS,
  SET_BUTTONS,
  SET_BUTTON_ADAPTIVE_TEXT,
  SET_BUTTON_BG_COLOR,
  SET_BUTTON_COLOR,
  SET_BUTTON_DYNAMIC_TEXT_CONFIG,
  SET_BUTTON_FONT_FAMILY,
  SET_BUTTON_FONT_SIZE,
  SET_BUTTON_FONT_STYLE,
  SET_BUTTON_IMAGE,
  SET_BUTTON_MARGIN,
  SET_BUTTON_PADDING,
  SET_BUTTON_TEXT,
  SET_BUTTON_TEXT_MARGIN,
  SET_BUTTON_TEXT_PADDING,
  SET_CLOSE_BUTTON_ACTION,
  SET_CLOSE_BUTTON_COLOR,
  SET_CLOSE_BUTTON_FILL_COLOR,
  SET_CLOSE_BUTTON_HEIGHT,
  SET_CLOSE_BUTTON_OFFSET_RIGHT,
  SET_CLOSE_BUTTON_OFFSET_TOP,
  SET_CLOSE_BUTTON_PATH,
  SET_CLOSE_BUTTON_SHAPE,
  SET_CLOSE_BUTTON_TYPE,
  SET_CLOSE_BUTTON_WIDTH,
  SET_COLOR,
  SET_DYNAMIC_TEXT_CONFIG,
  SET_ELEMENT_HIGHLIGHTER_BORDER_COLOR,
  SET_ELEMENT_HIGHLIGHTER_BORDER_OPACITY,
  SET_ELEMENT_HIGHLIGHTER_BORDER_WIDTH,
  SET_ELEMENT_HIGHLIGHTER_CORNER_RADIUS,
  SET_ELEMENT_HIGHLIGHTER_OFFSET_BOTTOM,
  SET_ELEMENT_HIGHLIGHTER_OFFSET_LEFT,
  SET_ELEMENT_HIGHLIGHTER_OFFSET_RADIUS,
  SET_ELEMENT_HIGHLIGHTER_OFFSET_RIGHT,
  SET_ELEMENT_HIGHLIGHTER_OFFSET_TOP,
  SET_ELEMENT_HIGHLIGHTER_SHAPE,
  SET_FONT_FAMILY,
  SET_FONT_SIZE,
  SET_FONT_STYLE,
  SET_IMAGE,
  SET_IMAGE_SIZE,
  SET_MEDIA_ICON_ALIGNMENT,
  SET_MEDIA_ICON_BORDER_COLOR,
  SET_MEDIA_ICON_BORDER_ENABLED,
  SET_MEDIA_ICON_BORDER_RADIUS,
  SET_MEDIA_ICON_BORDER_STYLE,
  SET_MEDIA_ICON_BORDER_WIDTH,
  SET_MEDIA_ICON_HEIGHT,
  SET_MEDIA_ICON_PATH,
  SET_MEDIA_ICON_WIDTH,
  SET_MEDIA_IMAGE_ACTION,
  SET_MEDIA_IMAGE_ACTION_ENABLED,
  SET_MEDIA_IMAGE_BORDER_COLOR,
  SET_MEDIA_IMAGE_BORDER_ENABLED,
  SET_MEDIA_IMAGE_BORDER_RADIUS,
  SET_MEDIA_IMAGE_BORDER_STYLE,
  SET_MEDIA_IMAGE_BORDER_WIDTH,
  SET_MEDIA_IMAGE_HEIGHT,
  SET_MEDIA_IMAGE_PATH,
  SET_MEDIA_IMAGE_WIDTH,
  SET_MEDIA_VIDEO_AUDIO_ENABLED,
  SET_MEDIA_VIDEO_BORDER_COLOR,
  SET_MEDIA_VIDEO_BORDER_ENABLED,
  SET_MEDIA_VIDEO_BORDER_RADIUS,
  SET_MEDIA_VIDEO_BORDER_STYLE,
  SET_MEDIA_VIDEO_BORDER_WIDTH,
  SET_MEDIA_VIDEO_EMBED_ENABLED,
  SET_MEDIA_VIDEO_EMBED_HTML,
  SET_MEDIA_VIDEO_HEIGHT,
  SET_MEDIA_VIDEO_PATH,
  SET_MEDIA_VIDEO_WIDTH,
  SET_MODAL_MARGIN_BOTTOM,
  SET_MODAL_MARGIN_LEFT,
  SET_MODAL_MARGIN_RIGHT,
  SET_MODAL_MARGIN_TOP,
  SET_MODAL_PADDING_BOTTOM,
  SET_MODAL_PADDING_LEFT,
  SET_MODAL_PADDING_RIGHT,
  SET_MODAL_PADDING_TOP,
  SET_MODULE_TYPE,
  SET_NEW_ADAPTIVE_TEXT,
  SET_NEW_BORDER_COLOR,
  SET_NEW_BORDER_ENABLED,
  SET_NEW_BORDER_RADIUS,
  SET_NEW_BORDER_STYLE,
  SET_NEW_BORDER_WIDTH,
  SET_NEW_BUTTON_ACTION_ENABLED,
  SET_NEW_BUTTON_ACTION_TYPE,
  SET_NEW_BUTTON_ADAPTIVE_TEXT,
  SET_NEW_BUTTON_BG_COLOR,
  SET_NEW_BUTTON_BORDER_COLOR,
  SET_NEW_BUTTON_BORDER_ENABLED,
  SET_NEW_BUTTON_BORDER_RADIUS,
  SET_NEW_BUTTON_BORDER_STYLE,
  SET_NEW_BUTTON_BORDER_WIDTH,
  SET_NEW_BUTTON_DYNAMIC_TEXT,
  SET_NEW_BUTTON_FONT_FAMILY,
  SET_NEW_BUTTON_FONT_SIZE,
  SET_NEW_BUTTON_FONT_STYLE,
  SET_NEW_BUTTON_FONT_WEIGHT,
  SET_NEW_BUTTON_MARGIN,
  SET_NEW_BUTTON_PADDING,
  SET_NEW_BUTTON_TOP_DIST,
  SET_NEW_BUTTON_LEFT_DIST,
  SET_NEW_BUTTON_REDIRECT_TYPE,
  SET_NEW_BUTTON_REDIRECT_URL,
  SET_NEW_BUTTON_TEXT,
  SET_NEW_BUTTON_TEXT_COLOR,
  SET_NEW_BUTTON_TEXT_MARGIN,
  SET_NEW_BUTTON_TEXT_PADDING,
  SET_NEW_CONFIG_COACHMARK_ARROW_ANGLE,
  SET_NEW_CONFIG_COACHMARK_ARROW_ASPECT_RATIO,
  SET_NEW_CONFIG_COACHMARK_ARROW_BORDER_PROPERTY,
  SET_NEW_CONFIG_COACHMARK_ARROW_DIMENSION,
  SET_NEW_CONFIG_COACHMARK_ARROW_ENABLE_BORDER,
  SET_NEW_CONFIG_COACHMARK_ARROW_OFFSET,
  SET_NEW_CONFIG_COACHMARK_ARROW_PATH,
  SET_NEW_CONFIG_COACHMARK_ARROW_POSITION,
  SET_NEW_CONFIG_COACHMARK_ARROW_TYPE,
  SET_NEW_CONFIG_COACHMARK_ENABLE_RIPPLE,
  SET_NEW_CONFIG_COACHMARK_IMAGE_ASPECT_RATIO,
  SET_NEW_CONFIG_COACHMARK_IMAGE_BORDER_PROPERTY,
  SET_NEW_CONFIG_COACHMARK_IMAGE_DIMENSION,
  SET_NEW_CONFIG_COACHMARK_IMAGE_ENABLE_BORDER,
  SET_NEW_CONFIG_COACHMARK_IMAGE_OFFSET,
  SET_NEW_CONFIG_COACHMARK_IMAGE_PATH,
  SET_NEW_CONFIG_COACHMARK_IMAGE_POSITION,
  SET_NEW_CONFIG_COACHMARK_IMAGE_TYPE,
  SET_NEW_CONFIG_COACHMARK_RIPPLE_COLOR,
  SET_NEW_CONFIG_COACHMARK_RIPPLE_DURATION,
  SET_NEW_CONFIG_COACHMARK_RIPPLE_OPACITY,
  SET_NEW_CONFIG_COACHMARK_RIPPLE_TYPE,
  SET_NEW_CONFIG_COACHMARK_RIPPLE_WIDTH,
  SET_NEW_CONFIG_CONTENT_BUTTON_BORDER_ENABLED,
  SET_NEW_CONFIG_CONTENT_BUTTON_BORDER_PROPERTY,
  SET_NEW_CONFIG_CONTENT_BUTTON_COLOR,
  SET_NEW_CONFIG_CONTENT_BUTTON_ENABLE_ACTION,
  SET_NEW_CONFIG_CONTENT_BUTTON_ENABLE_ACTION_TYPE,
  SET_NEW_CONFIG_CONTENT_BUTTON_ENABLE_REDIRECT_TYPE,
  SET_NEW_CONFIG_CONTENT_BUTTON_ENABLE_REDIRECT_URL,
  SET_NEW_CONFIG_CONTENT_BUTTON_MARGIN,
  SET_NEW_CONFIG_CONTENT_BUTTON_PADDING,
  SET_NEW_CONFIG_CONTENT_ENABLE_DESC,
  SET_NEW_CONFIG_CONTENT_ENABLE_TITLE,
  SET_NEW_CONFIG_CONTENT_HEIGHT,
  SET_NEW_CONFIG_CONTENT_MARGIN,
  SET_NEW_CONFIG_CONTENT_OFFSET,
  SET_NEW_CONFIG_CONTENT_POSITION,
  SET_NEW_CONFIG_CONTENT_TEXT,
  SET_NEW_CONFIG_CONTENT_TEXT_ALIGNMENT,
  SET_NEW_CONFIG_CONTENT_TEXT_COLOR,
  SET_NEW_CONFIG_CONTENT_TEXT_FONT_PROPERTY,
  SET_NEW_CONFIG_CONTENT_TEXT_MARGIN,
  SET_NEW_CONFIG_CONTENT_TEXT_PADDING,
  SET_NEW_CONFIG_CONTENT_WIDTH,
  SET_NEW_CONFIG_ELEMENT_HIGHLIGHTER_BORDER_COLOR,
  SET_NEW_CONFIG_ELEMENT_HIGHLIGHTER_BORDER_ENABLE,
  SET_NEW_CONFIG_ELEMENT_HIGHLIGHTER_BORDER_OPACITY,
  SET_NEW_CONFIG_ELEMENT_HIGHLIGHTER_BORDER_RADIUS,
  SET_NEW_CONFIG_ELEMENT_HIGHLIGHTER_BORDER_STYLE,
  SET_NEW_CONFIG_ELEMENT_HIGHLIGHTER_BORDER_WIDTH,
  SET_NEW_CONFIG_ELEMENT_HIGHLIGHTER_SHAPE,
  SET_NEW_DYNAMIC_TEXT_CONFIG,
  SET_NEW_FONT_FAMILY,
  SET_NEW_FONT_SIZE,
  SET_NEW_FONT_STYLE,
  SET_NEW_FONT_WEIGHT,
  SET_NEW_TEXT_ALIGNMENT,
  SET_ONBOARDING_ACTION_BUTTON_MARGIN,
  SET_ONBOARDING_ANIM_DURATION,
  SET_ONBOARDING_ANIM_TYPE,
  SET_ONBOARDING_BACKGROUND_COLOR,
  SET_ONBOARDING_BORDER_COLOR,
  SET_ONBOARDING_BORDER_WIDTH,
  SET_ONBOARDING_BOTTOM_PAD,
  SET_ONBOARDING_BTN_ADAPTIVE_TEXT,
  SET_ONBOARDING_BTN_BACKGROUND_COLOR,
  SET_ONBOARDING_BTN_COLOR,
  SET_ONBOARDING_BTN_FONT_FAMILY,
  SET_ONBOARDING_BTN_FONT_SIZE,
  SET_ONBOARDING_BTN_FONT_STYLE,
  SET_ONBOARDING_BTN_TEXT,
  SET_ONBOARDING_CORNER_WIDTH,
  SET_ONBOARDING_COUNTER_BOTTOM_DISTANCE,
  SET_ONBOARDING_COUNTER_COLOR,
  SET_ONBOARDING_COUNTER_FONT_FAMILY,
  SET_ONBOARDING_COUNTER_FONT_STYLE,
  SET_ONBOARDING_COUNTER_LEFT_DISTANCE,
  SET_ONBOARDING_COUNTER_TEXT,
  SET_ONBOARDING_COUNTER_TEXT_SIZE,
  SET_ONBOARDING_DISMISS_ACTION,
  SET_ONBOARDING_DISMISS_TYPE,
  SET_ONBOARDING_DIVIDER_COLOR,
  SET_ONBOARDING_DIVIDER_ENABLED,
  SET_ONBOARDING_DIVIDER_HEIGHT,
  SET_ONBOARDING_DIVIDER_MARGIN,
  SET_ONBOARDING_DOTS_ACTIVE_COLOR,
  SET_ONBOARDING_DOTS_BOTTOM_DIST,
  SET_ONBOARDING_DOTS_DISTANCE,
  SET_ONBOARDING_DOTS_INACTIVE_COLOR,
  SET_ONBOARDING_DOTS_OPACITY,
  SET_ONBOARDING_DOTS_RADIUS,
  SET_ONBOARDING_FADEOUT_OPACITY,
  SET_ONBOARDING_HORIZONTAL_MARGIN,
  SET_ONBOARDING_IMAGE_POSITION,
  SET_ONBOARDING_LAST_STEP_TEXT,
  SET_ONBOARDING_LEFT_PAD,
  SET_ONBOARDING_MESSAGE_POSITION,
  SET_ONBOARDING_PAGINATION_TYPE,
  SET_ONBOARDING_PREV_NEXT_DIST,
  SET_ONBOARDING_RIGHT_PAD,
  SET_ONBOARDING_SKIP_RIGHT,
  SET_ONBOARDING_SKIP_TOP,
  SET_ONBOARDING_TEXT_MARGIN,
  SET_ONBOARDING_TEXT_PADDING,
  SET_ONBOARDING_TOOLTIP_MARGIN,
  SET_ONBOARDING_TOP_PAD,
  SET_ONBOARDING_VERTICAL_MARGIN,
  SET_PIP_BUTTON_COLOR,
  SET_PIP_BUTTON_FILL_COLOR,
  SET_PIP_BUTTON_HEIGHT,
  SET_PIP_BUTTON_OFFSET_LEFT,
  SET_PIP_BUTTON_OFFSET_TOP,
  SET_PIP_BUTTON_PATH,
  SET_PIP_BUTTON_SHAPE,
  SET_PIP_BUTTON_TYPE,
  SET_PIP_BUTTON_WIDTH,
  SET_ROW_NAME,
  SET_SCROLLABLE,
  SET_SCROLLABLE_BORDER,
  SET_SCROLLABLE_BORDER_COLOR,
  SET_SCROLLABLE_BORDER_RADIUS,
  SET_SCROLLABLE_BORDER_STYLE,
  SET_SCROLLABLE_BORDER_WIDTH,
  SET_SCROLLABLE_HEIGHT,
  SET_SHADOW_BLUR_RADIUS,
  SET_SHADOW_COLOR,
  SET_SHADOW_ENABLED,
  SET_SHADOW_OFFSET_X,
  SET_SHADOW_OFFSET_Y,
  SET_SHADOW_SPREAD_RADIUS,
  SET_SLOT_NUMBER,
  SWAP_BUTTON_SLOTS,
  SET_TEXT,
  SET_TEXT_ALIGNMENT,
  SET_TITLE_ICON_BORDER_COLOR,
  SET_TITLE_ICON_BORDER_ENABLED,
  SET_TITLE_ICON_BORDER_RADIUS,
  SET_TITLE_ICON_BORDER_STYLE,
  SET_TITLE_ICON_BORDER_WIDTH,
  SET_TITLE_ICON_HEIGHT,
  SET_TITLE_ICON_PATH,
  SET_TITLE_ICON_WIDTH,
  SET_TOOLTIP_IMAGE_TYPE,
  SET_TOOLTIP_IMAGE_URL,
  SET_VIDEO_BUTTON_COLOR,
  SKIP_BUTTON_STATE,
} from "../../constants"
import { useTracked, useTrackedState } from "../../store"
import {
  ARROW_CONFIG,
  BACKGROUND_OFFSET_CONFIG,
  BADGE_BACKGROUND_CONFIG,
  BADGE_POSITION_CONFIG,
  BORDER_CONFIG,
  CLOSE_CONFIG,
  DESCRIPTION,
  INITIAL_BADGE_STATE,
  MARGIN,
  MARGIN_CONFIG,
  MEDIA_ICON_CONFIG,
  MEDIA_IMAGE_CONFIG,
  MEDIA_VIDEO_CONFIG,
  NEW_COACHMARKS_ARROW,
  NEW_COACHMARKS_BACKGROUND,
  NEW_COACHMARKS_IMAGE,
  NEW_INLINE_POSITION_CONFIG,
  ONE_BADGE_VARIANT_CONFIG,
  PADDING,
  PADDING_CONFIG,
  PIP_BUTTON_CONFIG,
  POSITION_ENUM,
  SCROLL_CONFIG,
  SHADOW_CONFIG,
  TITLE,
} from "../../templates/common"
import {
  PlaceHolderButton,
  convertToPaddingOrMargin,
} from "./components/inappSimulator/modals"

export const DEFAULT_IMAGE_DATA =
  "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"

const getFontStyle = (option) => {
  switch (option) {
    case "bold":
      return {
        fontWeight: 600,
      }
    case "bold_italic":
      return {
        fontWeight: 600,
        fontStyle: "italic",
      }
    case "italic":
      return {
        fontStyle: "italic",
      }
    default:
      return {}
  }
}

export const BUTTONS_POSITION = Object.freeze({
  RIGHT: "right",
  LEFT: "left",
})

export const BTN_ACTION_ENUM = Object.freeze({
  DISMISS: "dismiss",
  CANCEL: "cancel",
  REDIRECT: "redirect",
  NEVER_SHOW: "never",
})

export const COACHMARK_BTN_ACTION_ENUM = Object.freeze({
  DISMISS: "dismiss",
  CANCEL: "cancel",
  REDIRECT: "redirect",
  NEVER_SHOW: "never",
})

const getButtonPosition = (buttonPosition) => {
  switch (buttonPosition) {
    case BUTTONS_POSITION.RIGHT:
      return "flex-end"
    case BUTTONS_POSITION.LEFT:
      return "flex-start"
    default:
      return "flex-end"
  }
}

export const translateToFontConfig = (text_config) => {
  const { color, font_family, size, style, alignment } = text_config

  return {
    color,
    fontFamily: font_family,
    fontSize: `${size}px`,
    fontStyle: style !== "bold" ? style : "normal",
    fontWeight: style === "bold" ? style : "normal",
    margin: 0,
    padding: 0,
    lineHeight: `${Number(size) + 2}px`,
    textAlign: alignment ?? "left",
  }
}

export const newTranslateToFontConfig = (text_config) => {
  const { color, font_family, size, style, alignment, weight } = text_config

  return {
    color,
    fontFamily: font_family,
    fontSize: `${size}px`,
    fontStyle: style === "italic" ? style : "normal",
    fontWeight: weight === "bold" ? "bold" : "normal",
    margin: 0,
    padding: 0,
    lineHeight: `${Number(size) + 2}px`,
    textAlign: alignment ?? "left",
  }
}

export function generateFontConfig(config) {
  const {
    color = TITLE.title.color,
    alignment = TITLE.title.alignment,
    font: {
      family = TITLE.title.font.family,
      size = TITLE.title.font.size,
      style = TITLE.title.font.style,
      weight = TITLE.title.font.weight,
    } = TITLE.title.font,
  } = config

  return {
    color: color ?? TITLE.title.font.color,
    fontFamily: family ?? TITLE.title.font.family,
    fontSize: size ?? TITLE.title.font.size,
    fontStyle: style ?? TITLE.title.font.style,
    fontWeight: weight ?? TITLE.title.font.weight,
    margin: 0,
    padding: 0,
    lineHeight: `${Number(size) + 2}px`,
    textAlign: alignment,
  }
}

export const StyledHolder = styled.div`
  user-select: none;
  padding: 0px;
  transition: all 0.1s ease-in-out;
  ${(props) =>
    props.selected
      ? "border: 1px dashed #2979ff;"
      : "border: 1px solid transparent;"}
  &:hover {
    box-shadow: ${(props) =>
      props.defaultBgColor ? "none" : "0 3px 3px rgba(18, 66, 74, 0.25)"};
    cursor: pointer;
    background: ${(props) =>
      props.bgColor
        ? tinyColor2(props.bgColor).complement().toHexString()
        : props.defaultBgColor || "#ffffff"};
    border: ${(props) => (props.isPure ? "none" : "1px solid #2979ff")};
  }
  width: ${(props) => (props.isPure ? "100%" : "unset")};
`

const userSessionRegex = /(\[(user|session)_[\w\s]+\([\w\s]+\)\])+/gm
const dynamicTextRegex = /(\[([a-zA-Z;]+)(v[\d]+);([\d\w\p\s;\[\]-]+)\])+/gm

function renderMacros(text = "") {
  let renderedText = text
  let m

  while ((m = userSessionRegex.exec(text)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === userSessionRegex.lastIndex) {
      userSessionRegex.lastIndex++
    }

    for (let groupIndex = 0; groupIndex < m.length; groupIndex++) {
      const match = m[groupIndex]
      if (groupIndex === 0) {
        const macro = match
        const defaultValue = match.substring(
          match.indexOf("(") + 1,
          match.indexOf(")"),
        )
        renderedText = renderedText.replace(macro, defaultValue)
      }
    }
  }

  // Replace DynamicText macors
  const temp = renderedText
  while ((m = dynamicTextRegex.exec(temp)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === dynamicTextRegex.lastIndex) {
      dynamicTextRegex.lastIndex++
    }

    let defaultValue = m[4]
    renderedText = renderedText.replace(m[0], defaultValue)
  }
  return renderedText
}

export function TitleHolder({
  id,
  bgColor,
  title = TITLE.title,
  handleModuleSelection,
  selected = false,
  style = {},
}) {
  const newLineTransformation = useMemo(
    () => renderMacros(title.text)?.trim(),
    [title.text],
  )

  const fontConfig = generateFontConfig(title)

  return (
    <StyledHolder
      id={id}
      bgColor={bgColor}
      selected={selected}
      onClick={handleModuleSelection}
    >
      <div
        id={"title_" + id}
        style={{
          minWidth: 50,
          minHeight: 20,
          ...fontConfig,
          ...style,
          whiteSpace: "pre-wrap",
          lineHeight: `${fontConfig.fontSize}px`,
        }}
      >
        {newLineTransformation}
      </div>
    </StyledHolder>
  )
}

export function DescriptionHolder({
  id,
  bgColor,
  description = DESCRIPTION.description,
  handleModuleSelection,
  selected = false,
  style = {},
}) {
  const newLineTransformation = useMemo(
    () => renderMacros(description.text)?.trim(),
    [description.text],
  )

  const fontConfig = generateFontConfig(description)

  return (
    <StyledHolder
      id={id}
      bgColor={bgColor}
      selected={selected}
      onClick={handleModuleSelection}
      style={{
        borderRadius: style.borderRadius ?? 0,
      }}
    >
      <div
        id={"description_" + id}
        style={{
          minWidth: 50,
          minHeight: 20,
          ...fontConfig,
          ...style,
          lineHeight: `normal`,
          whiteSpace: "pre-wrap",
        }}
      >
        {newLineTransformation}
      </div>
    </StyledHolder>
  )
}

export function TextHolder({
  id,
  isPure = false,
  bgColor,
  config,
  handleModuleSelection,
  selected = false,
  style = {},
}) {
  const { text = "Text", ...others } = config
  const newLineTransformation = useMemo(() => renderMacros(text), [text])

  return isPure ? (
    <div style={{ ...translateToFontConfig(others), ...style }}>
      {newLineTransformation}
    </div>
  ) : (
    <StyledHolder
      id={id}
      bgColor={bgColor}
      selected={selected}
      onClick={handleModuleSelection}
    >
      <div
        id={"text_" + id}
        style={{
          minWidth: 50,
          minHeight: 20,
          ...translateToFontConfig(others),
          ...style,
          whiteSpace: "pre-wrap",
        }}
      >
        {newLineTransformation.trim()}
      </div>
    </StyledHolder>
  )
}

export function NewTextHolder({
  id,
  config,
  handleModuleSelection,
  dispatch,
  style = {},
}) {
  const { currentStep } = useTrackedState()
  const { text = "Text" } = config
  const [hovered, setHovered] = useState(false)
  const newLineTransformation = useMemo(() => renderMacros(text), [text])
  const {
    margin,
    font: { size, style: font_style, family, weight },
    padding,
    color,
    alignment,
  } = config

  return (
    <NewStyledHolder
      id={id}
      onClick={handleModuleSelection}
      style={{
        ...style,
        position: "relative",
        margin: `${margin.top}px ${margin.right}px ${margin.bottom}px ${margin.left}px`,
        padding: `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`,
      }}
      onMouseEnter={(e) => {
        e.stopPropagation()
        setHovered(true)
      }}
      onMouseLeave={() => {
        setHovered(false)
      }}
    >
      {hovered && (
        <ThemedTooltip
          title="Delete"
          dark
        >
          <IconButton
            size="small"
            style={{
              backgroundColor: apxTheme.palette.action.focus,
              position: "absolute",
              top: -10,
              left: -12,
            }}
            onClick={(e) => {
              e.stopPropagation()
              sendEvent(HIDE_CONFIGURATION_TOOLBARS)
              dispatch({
                type:
                  id === "title_config"
                    ? SET_NEW_CONFIG_CONTENT_ENABLE_TITLE
                    : SET_NEW_CONFIG_CONTENT_ENABLE_DESC,
                currentStep,
                value: false,
              })
            }}
          >
            <IconTrash
              style={{
                color: "#F12D2D",
                width: 14,
                height: 14,
              }}
            />
          </IconButton>
        </ThemedTooltip>
      )}
      <div
        id={"text_" + id}
        style={{
          ...newTranslateToFontConfig({
            color,
            size,
            style: font_style,
            alignment,
            font_family: family,
            weight: weight,
          }),
          whiteSpace: "pre-wrap",
        }}
      >
        {newLineTransformation.trim()}
      </div>
    </NewStyledHolder>
  )
}

export function HeaderFooterImageHolder({
  id,
  style,
  config = "",
  handleModuleSelection = null,
  selected = false,
  size = null,
}) {
  return (
    <StyledHolder
      id={id}
      style={{
        margin: size !== null ? 10 : 0,
        maxWidth: size !== null ? "60%" : 64,
        width: size !== null ? `${size}%` : 64,
        height: size !== null ? "auto" : 64,
        display: "inline-flex",
        padding: 0,
        ...style,
      }}
      selected={selected}
      onClick={handleModuleSelection}
    >
      <img
        alt=""
        src={
          config === "" ? "data:image/png;base64," + DEFAULT_IMAGE_DATA : config
        }
        style={{
          width: "100%",
          height: "100%",
        }}
      />
    </StyledHolder>
  )
}

export function ImageHolder({
  id,
  isPure,
  style,
  newUI,
  config = "",
  handleModuleSelection = null,
  selected = false,
  type = "FILE",
  useImgTag = true,
  imageType = "upload",
}) {
  const hasImageSize = newUI && newUI.image_size

  return isPure ? (
    <div
      id={id}
      style={{
        width: 64,
        height: 64,
        padding: 0,
        minWidth: type === "FILE" ? 0 : 64,
        minHeight: type === "FILE" ? 0 : 64,
        ...style,
      }}
    >
      {imageType === "upload" && (
        <img
          alt={"some_image"}
          src={
            type === "FILE"
              ? "data:image/png;base64," +
                (config === "" ? DEFAULT_IMAGE_DATA : config)
              : config === ""
                ? "data:image/png;base64," + DEFAULT_IMAGE_DATA
                : config
          }
          style={{ width: "100%", height: "100%" }}
        />
      )}
      {imageType === "url" && (
        <img
          alt={"some_image"}
          src={config}
          style={{ width: "100%", height: "100%" }}
        />
      )}
    </div>
  ) : (
    <StyledHolder
      id={id}
      style={{
        width: 64,
        height: 64,
        padding: 0,
        minWidth: type === "FILE" ? 0 : 64,
        minHeight: type === "FILE" ? 0 : 64,
        backgroundSize: !useImgTag
          ? hasImageSize &&
            (newUI.image_size === "Stretch"
              ? "100% 100%"
              : newUI.image_size.toLowerCase())
          : "",
        backgroundPosition: !useImgTag ? "center" : "",
        backgroundRepeat: !useImgTag ? "no-repeat" : "",
        backgroundImage: !useImgTag
          ? 'url("' +
            (config === ""
              ? "data:image/png;base64," + DEFAULT_IMAGE_DATA
              : config) +
            '")'
          : "",
        ...style,
      }}
      selected={selected}
      onClick={handleModuleSelection}
    >
      {useImgTag && imageType === "upload" && (
        <img
          alt=""
          src={
            type === "FILE"
              ? "data:image/png;base64," +
                (config === "" ? DEFAULT_IMAGE_DATA : config)
              : config === ""
                ? "data:image/png;base64," + DEFAULT_IMAGE_DATA
                : config
          }
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      )}
      {useImgTag && imageType === "url" && (
        <img
          alt={"some_image"}
          src={config}
          style={{ width: "100%", height: "100%" }}
        />
      )}
    </StyledHolder>
  )
}

export function ButtonConfig({
  config: { text_config, color, gradient_config, borders },
  index,
  moduleType,
  onModuleSelection,
  style,
  textStyles = {},
}) {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation()
        onModuleSelection(e, MODULE_TYPES.BUTTON + (index + 1))
      }}
      style={{
        padding: "2px 12px",
        background:
          color === "#"
            ? "transparent"
            : gradient_config
              ? `linear-gradient(${gradient_config.colors.join(",")})`
              : color,
        color: text_config?.color || "#ffffff",
        fontFamily: text_config?.font_family || "sans-serif",
        borderRadius: borders?.radius ?? 4,
        fontSize: Number(text_config?.size) || 12,
        ...style,
        ...getFontStyle(text_config?.style?.toLowerCase()),
      }}
    >
      <StyledHolder
        selected={moduleType === MODULE_TYPES.BUTTON_TEXT + (index + 1)}
        isPure={true}
        style={{
          ...textStyles,
          fontFamily: text_config?.font_family || "sans-serif",
          whiteSpace: "pre-wrap",
          minHeight: "10px",
          minWidth: "10px",
        }}
        onClick={(e) => {
          e.stopPropagation()
          onModuleSelection(e, MODULE_TYPES.BUTTON_TEXT + (index + 1))
        }}
      >
        {text_config.text}
      </StyledHolder>
    </div>
  )
}

export function NewCoachmarkButtonConfig({
  config,
  index,
  moduleType,
  onModuleSelection,
}) {
  const {
    text,
    color,
    enable_border,
    padding,
    margin,
    border: {
      radius,
      color: borderColor,
      width: borderWidth,
      style: borderStyle,
    },
  } = config
  return (
    <HoverDiv
      onClick={(e) => {
        e.stopPropagation()
        onModuleSelection(e, MODULE_TYPES.NEW_COACHMARK_BUTTON + (index + 1))
      }}
      style={{
        padding: `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`,
        margin: `${margin.top}px ${margin.right}px ${margin.bottom}px ${margin.left}px`,
        backgroundColor: color === "#" ? "transparent" : color,
        color: text?.color,
        fontFamily: text?.font.family,
        borderColor: borderColor,
        borderWidth: enable_border ? borderWidth : 0,
        borderStyle: borderStyle,
        borderRadius: enable_border ? radius : 0,
        fontSize: Number(text?.size),
        whiteSpace: "pre-wrap",
        ...getFontStyle(text?.font.style.toLowerCase()),
      }}
    >
      <StyledHolder
        selected={
          moduleType === MODULE_TYPES.NEW_COACHMARK_BUTTON_TEXT + (index + 1)
        }
        isPure={true}
        style={{
          ...newTranslateToFontConfig({
            color: text.color,
            size: text.font.size,
            style: text.font.style,
            alignment: text.alignment,
            font_family: text.font.family,
            weight: text.font.weight,
          }),
          minWidth: 10,
          minHeight: 10,
        }}
        onClick={(e) => {
          e.stopPropagation()
          onModuleSelection(
            e,
            MODULE_TYPES.NEW_COACHMARK_BUTTON_TEXT + (index + 1),
          )
        }}
      >
        {text.text}
      </StyledHolder>
    </HoverDiv>
  )
}

export function NewButtonConfig({
  config,
  moduleType,
  onModuleSelection,
  slot = 0,
  row_name = "",
}) {
  const [state, dispatch] = useTracked()
  const { currentStep, uis = [] } = state
  const ui = uis[currentStep] || {}

  if (config?.type === "carousel" && ui?.ui?.carousal) {
    return (
      <div
        onClick={(e) => {
          e.stopPropagation()
          onModuleSelection(
            e,
            MODULE_TYPES.EXPLAINER_CAROUSEL_DOT,
            row_name,
            slot,
          )
          if (slot !== 0) {
            dispatch({
              type: SET_SLOT_NUMBER,
              value: slot,
            })
          }
          if (row_name) {
            dispatch({
              type: SET_ROW_NAME,
              value: row_name,
            })
          }
        }}
        style={{
          padding: convertToPaddingOrMargin(config?.padding),
          margin: convertToPaddingOrMargin(config?.margin, true),
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <DotCarousel
          activeStep={currentStep}
          totalSteps={uis.length}
          ui={ui.ui}
          carousal={ui.ui.carousal}
          counter={ui.ui.counter}
          onModuleSelection={onModuleSelection}
          moduleType={moduleType}
        />
      </div>
    )
  }

  if (config?.type === "carousel" && !ui?.ui?.carousal) {
    return null
  }

  return (
    <div
      onClick={(e) => {
        e.stopPropagation()
        onModuleSelection(e, MODULE_TYPES.NEW_BUTTON, row_name, slot)
        if (slot !== 0) {
          dispatch({
            type: SET_SLOT_NUMBER,
            value: slot,
          })
        }
        if (row_name) {
          dispatch({
            type: SET_ROW_NAME,
            value: row_name,
          })
        }
      }}
      style={{
        padding: convertToPaddingOrMargin(config?.padding),
        margin: convertToPaddingOrMargin(
          config?.margins || config?.margin,
          true,
        ),
        background:
          config?.bg_color ||
          (config?.color === "#" ? "transparent" : config?.color),
        color: (config?.text?.color || config?.color) ?? "#ffffff",
        fontFamily:
          (config?.text?.font?.family || config?.font_family) ?? "sans-serif",
        fontSize: Number(config?.text?.font?.size || config?.size) ?? 12,
        fontWeight: (config?.text?.font?.weight || config?.style) ?? "normal",
        fontStyle:
          (config?.text?.font?.style || config?.font_style) ?? "normal",
        border: config?.enable_border
          ? `${config?.border?.width}px ${config?.border?.style} ${config?.border?.color}`
          : "none",
        borderRadius:
          config?.border_radius ||
          (config?.enable_border ? `${config?.border?.radius}px` : 0),
        ...getFontStyle(
          (
            config?.text?.font?.style ||
            config?.style ||
            "normal"
          ).toLowerCase(),
        ),
      }}
    >
      <StyledHolder
        selected={moduleType === MODULE_TYPES.NEW_BUTTON_TEXT}
        isPure={true}
        style={{
          color: (config?.text?.color || config?.color) ?? "#ffffff",
          fontFamily:
            (config?.text?.font?.family || config?.font_family) ?? "sans-serif",
          fontSize: Number(config?.text?.font?.size || config?.size) ?? 12,
          fontWeight: (config?.text?.font?.weight || config?.style) ?? "normal",
          fontStyle:
            (config?.text?.font?.style || config?.font_style) ?? "normal",
          padding: convertToPaddingOrMargin(config?.text?.padding),
          margin: convertToPaddingOrMargin(
            config?.text?.margin || config?.margins,
            true,
          ),
          lineHeight: "normal",
          whiteSpace: "pre-wrap",
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: "100%",
          minHeight: "100%",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.stopPropagation()
          onModuleSelection(e, MODULE_TYPES.NEW_BUTTON_TEXT, row_name, slot)
          if (slot !== 0) {
            dispatch({
              type: SET_SLOT_NUMBER,
              value: slot,
            })
          }
          if (row_name) {
            dispatch({
              type: SET_ROW_NAME,
              value: row_name,
            })
          }
        }}
      >
        {typeof config?.text === "string" ? config?.text : config?.text?.text}
      </StyledHolder>
    </div>
  )
}

function OneButton({
  oneButton,
  index,
  bgColor,
  buttonStyledHolderStyle,
  isPure,
  row_name,
  totalButtons,
  rowEmpty,
  onModuleSelection,
  isExperiment = false,
}) {
  const [
    {
      moduleType,
      currentStep,
      enable_button_placement_mode,
      enable_buttons_slots_update_mode,
    },
    dispatch,
  ] = useTracked()
  const [btnHovered, setBtnHovered] = useState(null)

  const id = useId()

  return (
    <>
      {oneButton.taken ? (
        <StyledHolder
          onMouseEnter={() => {
            setBtnHovered(index)
          }}
          onMouseLeave={() => {
            setBtnHovered(null)
          }}
          onClick={(e) => {
            e.stopPropagation()
            // Also trigger onModuleSelection for button background click
            onModuleSelection(e, MODULE_TYPES.NEW_BUTTON)
          }}
          bgColor={bgColor}
          id={id}
          selected={moduleType === MODULE_TYPES.NEW_BUTTON}
          isPure={isPure}
          style={{
            ...buttonStyledHolderStyle,
            position: "relative",
            margin: convertToPaddingOrMargin(
              oneButton.config?.margins || oneButton.config?.margin,
              true,
            ),
          }}
        >
          {/* Delete Icon */}
          {btnHovered === index && (
            <ThemedTooltip
              title="Delete Button"
              dark
            >
              <IconButton
                size="small"
                style={{
                  backgroundColor: apxTheme.palette.action.focus,
                  position: "absolute",
                  top: -10,
                  left: -12,
                }}
                onClick={() => {
                  dispatch({
                    type: SET_BUTTONS,
                    operation: "delete",
                    isExperiment,
                    row_name,
                    slot: oneButton.config.slot,
                    currentStep,
                    count: totalButtons,
                    key: "buttons",
                    isActionButtons: false,
                  })
                }}
              >
                <DeleteIcon
                  style={{
                    color: "#F12D2D",
                    width: 15,
                    height: 15,
                  }}
                />
              </IconButton>
            </ThemedTooltip>
          )}
          <NewButtonConfig
            config={oneButton.config}
            key={`buttons_${index}`}
            onModuleSelection={(e, moduleName) => {
              // Ensure event is passed through
              onModuleSelection(e, moduleName)
            }}
            moduleType={moduleType}
            slot={oneButton.config.slot}
            row_name={row_name}
          />
        </StyledHolder>
      ) : (
        <>
          {enable_button_placement_mode || enable_buttons_slots_update_mode ? (
            <PlaceHolderButton
              buttonsCount={totalButtons}
              num={oneButton.config.slot}
              row_name={row_name}
              isExperiment={isExperiment}
            />
          ) : (
            <></>
          )}
        </>
      )}
    </>
  )
}

export function NewButtonsHolder({
  id,
  bgColor,
  config,
  style,
  buttonHolderStyle,
  buttonStyledHolderStyle = {},
  buttonPosition = BUTTONS_POSITION.RIGHT,
  moduleType,
  onModuleSelection,
  isPure = false,
  totalButtons = 5,
  buttonsCount = 5,
  row_name,
  enable_button_placement_mode,
  rowEmpty,
  isBottomButtons = false,
  enable_buttons_slots_update_mode = false,
  size = 45,
  isExperiment = false,
  ...others
}) {
  const [{ currentStep }, dispatch] = useTracked()
  const [dragOverSlot, setDragOverSlot] = useState(null)
  const dragSourceSlot = useRef(null)
  const dragSourcePosition = useRef(null)

  const furnishedConfig = useDeepCompareMemo(() => {
    const takenSlots = config.map((oneButton) => oneButton.slot)

    return Array.from({ length: totalButtons }, (_, i) => {
      if (takenSlots.includes(i + 1)) {
        return {
          taken: true,
          config: config.find((oneButton) => oneButton.slot === i + 1),
        }
      } else {
        return { taken: false, config: { slot: i + 1 } }
      }
    })
  }, [config, totalButtons])

  const handleDragStart = useCallback(
    (e, slot) => {
      const position = row_name || "bottom"
      dragSourceSlot.current = slot
      dragSourcePosition.current = position
      e.dataTransfer.effectAllowed = "move"
      // Store both slot and position in dataTransfer so it works across different component instances
      e.dataTransfer.setData(
        "application/json",
        JSON.stringify({ slot, position }),
      )
    },
    [row_name],
  )

  const handleDragOver = useCallback((e, slot) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = "move"
    setDragOverSlot(slot)
  }, [])

  const handleDragLeave = useCallback(() => {
    setDragOverSlot(null)
  }, [])

  const handleDrop = useCallback(
    (e, toSlot) => {
      e.preventDefault()
      setDragOverSlot(null)

      // Try to get data from dataTransfer first (for cross-component drops)
      let fromSlot = dragSourceSlot.current
      let fromPosition = dragSourcePosition.current

      try {
        const dragData = e.dataTransfer.getData("application/json")
        if (dragData) {
          const parsed = JSON.parse(dragData)
          fromSlot = parsed.slot
          fromPosition = parsed.position
        }
      } catch (err) {
        // If parsing fails, use refs as fallback
      }

      dragSourceSlot.current = null
      dragSourcePosition.current = null

      if (
        fromSlot == null ||
        (fromSlot === toSlot && fromPosition === row_name)
      )
        return
      dispatch({
        type: SWAP_BUTTON_SLOTS,
        fromSlot,
        fromPosition,
        toSlot,
        targetPosition: row_name || "bottom",
        currentStep,
        isExperiment,
      })
    },
    [currentStep, dispatch, isExperiment, row_name],
  )

  const handleDragEnd = useCallback(() => {
    setDragOverSlot(null)
    dragSourceSlot.current = null
    dragSourcePosition.current = null
  }, [])

  return (
    <div
      id={id}
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${totalButtons}, 1fr)`,
        alignItems: "center",
        gap: 4,
        padding: 0,
        ...buttonHolderStyle,
        width: "100%",
        boxSizing: "border-box",
        backgroundColor: enable_buttons_slots_update_mode
          ? totalButtons === buttonsCount
            ? apxTheme.palette.action.hover
            : "transparent"
          : "transparent",
        borderRadius: 12,
        border: enable_buttons_slots_update_mode
          ? `1px dotted ${apxTheme.palette.action.focus}`
          : "none",
        minHeight: "32px",
        ...style,
      }}
      {...others}
    >
      {config &&
        Array.isArray(config) &&
        furnishedConfig.map((oneButton, index) => {
          const slotNum = index + 1
          const isDragOver = dragOverSlot === slotNum
          return (
            <div
              key={`slot_${index}`}
              onDragOver={(e) => handleDragOver(e, slotNum)}
              onDragLeave={handleDragLeave}
              onDrop={(e) => handleDrop(e, slotNum)}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "32px",
                pointerEvents: enable_buttons_slots_update_mode
                  ? "none"
                  : "all",
                cursor: enable_buttons_slots_update_mode
                  ? "not-allowed"
                  : "auto",
                borderRadius: 6,
                outline: isDragOver
                  ? `2px dashed ${apxTheme.palette.primary.main}`
                  : "none",
                backgroundColor: isDragOver
                  ? apxTheme.palette.primary.light + "30"
                  : "transparent",
                transition: "outline 0.15s, background-color 0.15s",
              }}
            >
              <div
                draggable={oneButton.taken && !enable_buttons_slots_update_mode}
                onDragStart={(e) =>
                  oneButton.taken && handleDragStart(e, slotNum)
                }
                onDragEnd={handleDragEnd}
                style={{
                  cursor:
                    oneButton.taken && !enable_buttons_slots_update_mode
                      ? "grab"
                      : "auto",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <OneButton
                  oneButton={oneButton}
                  index={index}
                  bgColor={bgColor}
                  buttonStyledHolderStyle={buttonStyledHolderStyle}
                  isPure={isPure}
                  rowEmpty={rowEmpty}
                  row_name={row_name}
                  style={style}
                  totalButtons={totalButtons}
                  onModuleSelection={onModuleSelection}
                  isExperiment={isExperiment}
                />
              </div>
            </div>
          )
        })}
    </div>
  )
}

export function ButtonsHolder({
  id,
  bgColor,
  config,
  style,
  buttonHolderStyle,
  buttonStyledHolderStyle = {},
  buttonMarginRight = 8,
  buttonPosition = BUTTONS_POSITION.RIGHT,
  moduleType,
  onModuleSelection,
  isPure = false,
}) {
  return (
    <div
      id={id}
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: getButtonPosition(buttonPosition),
        ...buttonHolderStyle,
      }}
    >
      {config &&
        Array.isArray(config) &&
        config.map((oneButton, index) => (
          <StyledHolder
            key={`buttons_${index}`}
            bgColor={bgColor}
            selected={moduleType === MODULE_TYPES.BUTTON + (index + 1)}
            isPure={isPure}
            style={{ ...buttonStyledHolderStyle }}
          >
            <ButtonConfig
              style={{
                marginRight:
                  config.length > 1 && index === 0 ? buttonMarginRight : "",
                ...style,
              }}
              config={oneButton}
              key={`buttons_${index}`}
              onModuleSelection={onModuleSelection}
              moduleType={moduleType}
              index={index}
            />
          </StyledHolder>
        ))}
    </div>
  )
}

export function NewCoachmarksButtonsHolder({
  id,
  config,
  style,
  alignment,
  direction,
  onModuleSelection,
}) {
  const buttonPosition = useMemo(() => {
    if (direction === "H") {
      if (alignment === "L")
        return {
          flexDirection: "row",
          justifyContent: "start",
          alignItems: "start",
        }
      if (alignment === "R")
        return {
          flexDirection: "row",
          justifyContent: "end",
          alignItems: "start",
        }

      return {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "start",
      }
    } else {
      if (alignment === "L")
        return { flexDirection: "column", alignItems: "start" }
      if (alignment === "R")
        return { flexDirection: "column", alignItems: "end" }

      return { flexDirection: "column", alignItems: "center" }
    }
  }, [alignment, direction])
  return (
    <NewStyledHolder
      id={id}
      style={{
        display: "flex",
        minHeight: 10,
        ...buttonPosition,
      }}
    >
      {config &&
        Array.isArray(config) &&
        config.map((oneButton, index) => (
          <NewCoachmarkButtonConfig
            config={oneButton}
            index={index}
            onModuleSelection={onModuleSelection}
          />
        ))}
    </NewStyledHolder>
  )
}

export function VideoButtonHolder({ config, onModuleSelection, children }) {
  return (
    <IconButton
      style={{
        color: config?.color,
      }}
      onClick={(e) => {
        e.stopPropagation()
        onModuleSelection(e, MODULE_TYPES.VIDEO_BUTTON)
      }}
    >
      {children}
    </IconButton>
  )
}

export function CloseButtonHolder({
  config,
  moduleType,
  onModuleSelection,
  children,
  parentStyles,
  hasBg = false,
}) {
  return (
    <StyledHolder
      id={"close_button"}
      bgColor={"transparent"}
      selected={moduleType === MODULE_TYPES.CLOSE_BUTTON}
      style={{
        borderRadius: config?.shape === "circle" ? "50%" : "0px",
        display: "flex",
        flexDirection: "column",
        width: config?.width ?? 24,
        height: config?.height ?? 24,
        justifyContent: "center",
        alignItems: "center",
        ...parentStyles,
        color: config?.color,
        backgroundColor:
          (hasBg ? config?.backgroundColor : "transparent") ?? "transparent",
        border:
          moduleType === MODULE_TYPES.CLOSE_BUTTON
            ? "1px dashed #2979ff"
            : "transparent",
      }}
      onClick={(e) => {
        e.stopPropagation()
        onModuleSelection(e, MODULE_TYPES.CLOSE_BUTTON)
      }}
    >
      <div>{children}</div>
    </StyledHolder>
  )
}

export function PipButtonHolder({
  config,
  moduleType,
  onModuleSelection,
  children,
  parentStyles,
}) {
  return (
    <StyledHolder
      id={"pip_button"}
      bgColor={"transparent"}
      selected={moduleType === MODULE_TYPES.PIP_BUTTON}
      style={{
        borderRadius: 0,
        display: "flex",
        flexDirection: "column",
        width: config?.width ?? 24,
        height: config?.height ?? 24,
        justifyContent: "center",
        alignItems: "center",
        ...parentStyles,
        color: config?.color,
        backgroundColor: "transparent",
        border:
          moduleType === MODULE_TYPES.PIP_BUTTON
            ? "1px dashed #2979ff"
            : "transparent",
      }}
      onClick={(e) => {
        e.stopPropagation()
        onModuleSelection(e, MODULE_TYPES.PIP_BUTTON)
      }}
    >
      <div>{children}</div>
    </StyledHolder>
  )
}

export const getBorderWidth = (border) => {
  return border !== undefined ? border.width : 0
}

export const getArrowPosition = (position) => {
  switch (position) {
    case POSITION_ENUM.BOTTOM:
      return "bottom: 100%; left: 50%"
    case POSITION_ENUM.TOP:
      return "top: 100%; left: 50%"
    case POSITION_ENUM.LEFT:
      return "bottom: 50%; left: calc(100% + 12px);transform:translateY(50%);"
    case POSITION_ENUM.RIGHT:
      return "bottom: 50%; right: 100%;transform:translateY(50%);"
    default:
      return ""
  }
}

export const getTooltipArrow = (props) => {
  if (!props.border) {
    return `
        content: '';
        position: absolute;
        ${getArrowPosition(props.position)}
        margin-left: -12px;
        border-width: 12px;
        border-style: solid;
        border-left-color: transparent;
        border-top-color: transparent;
        border-right-color: transparent;
        border-bottom-color: transparent;
        border-${props.position.toLowerCase()}-color: ${props.bgColor};
    `
  } else {
    return `
        content: '';
        position: absolute;
        background: ${props.border.color};
        bottom: 100%;
        left: 50%;
        margin-left: -2px;
        height: 30px;
        width: 4px;
    `
  }
}

export const getTooltipArrowBulb = (props) => {
  return `
        content: '';
        position: absolute;
        margin-left: -6px;
        bottom: calc(100% + 24px);
        background: ${props.border.color};
        left: 50%;
        height: 12px
        width: 12px;
        border-radius: 8px;
        border: none;
    `
}

export const StyledDiv = styled.div`
  max-width: 360px;
  min-width: 180px;
  background-color: ${(props) => (props.bgColor ? props.bgColor : "#ff0000")};
  padding: 8px;
  position: relative;
  line-height: 24px;
  z-index: 5;
  border-radius: ${(props) => (props.cornerRadius ? props.cornerRadius : 0)}px;
  border: ${(props) =>
    props.border !== undefined
      ? getBorderWidth(props.border) + "px solid" + props.border.color
      : "inherit"};
  margin: 24px;
  &::after {
    ${(props) => (props.border ? getTooltipArrowBulb(props) : "content: '';")}
  }
  &::before {
    ${(props) => getTooltipArrow(props)}
  }
`

export const HoverDiv = styled.div`
  background: unset;
  &:hover {
    border: 1px solid #2979ff;
    box-shadow: ${(props) =>
      props.isFooter
        ? "0 -3px 3px rgba(18, 66, 74, 0.25)"
        : "0 3px 3px rgba(18, 66, 74, 0.25)"};
    cursor: pointer;
  }
`

export const NewStyledHolder = styled.div`
  user-select: none;
  padding: 0px;
  transition: all 0.1s ease-in-out;
  ${(props) =>
    props.selected
      ? "box-shadow: 0px 0px 1px 1.5px fuchsia;"
      : "box-shadow: none;"}
  &:hover {
    box-shadow: 0px 0px 1px 1.5px fuchsia;
    cursor: pointer;
    background: transparent;
  }
`

export const getLayoutBasedOnPosition = (position) => {
  switch (position) {
    case POSITION_ENUM.TOP:
      return {
        flexDirection: "column",
      }
    case POSITION_ENUM.LEFT:
      return {
        flexDirection: "row",
      }
    case POSITION_ENUM.BOTTOM:
      return {
        flexDirection: "column-reverse",
      }
    case POSITION_ENUM.RIGHT:
      return {
        flexDirection: "row-reverse",
      }
    default:
      return {
        flexDirection: "row",
      }
  }
}

export const getOffsetForInLineBasedOnPosition = (
  position,
  offset_config = { skid: 0, distance: 0 },
  enable_arrow = false,
) => {
  const skid = offset_config.skid
  const distance = enable_arrow ? 0 : offset_config.distance
  switch (position) {
    case POSITION_ENUM.TOP:
      return {
        margin: `0px 0px ${distance}px ${skid}px`,
      }
    case POSITION_ENUM.RIGHT:
      return {
        margin: `${skid}px 0px 0px ${distance}px`,
      }
    case POSITION_ENUM.BOTTOM:
      return {
        margin: `${distance}px 0px 0px ${skid}px`,
      }
    case POSITION_ENUM.LEFT:
      return {
        margin: `${skid}px ${distance}px 0px 0px`,
      }
    default:
      return {
        margin: ``,
      }
  }
}

export const getOffsetForInLineArrowBasedOnPosition = (
  position,
  offset_config = { skid: 0, distance: 0 },
) => {
  const skid = offset_config.skid
  const distance = offset_config.distance
  switch (position) {
    case POSITION_ENUM.TOP:
      return {
        margin: `0px 0px ${distance}px ${skid}px`,
      }
    case POSITION_ENUM.RIGHT:
      return {
        margin: `${skid}px 0px 0px ${distance}px`,
      }
    case POSITION_ENUM.BOTTOM:
      return {
        margin: `${distance}px 0px 0px ${skid}px`,
      }
    case POSITION_ENUM.LEFT:
      return {
        margin: `${skid}px ${distance}px 0px 0px`,
      }
    default:
      return {
        margin: ``,
      }
  }
}

export const getMarginBasedOnSkidDistance = (pos_offset, position) => {
  const { skid = 0, distance = 0 } = pos_offset
  switch (position) {
    case POSITION_ENUM.TOP:
      return `0px 0px ${distance}px ${skid}px`
    case POSITION_ENUM.BOTTOM:
      return `${distance}px 0px 0px ${skid}px`
    case POSITION_ENUM.RIGHT:
      return `${skid}px 0px 0px ${distance}px`
    case POSITION_ENUM.LEFT:
      return `${skid}px ${distance}px 0px 0px`
    default:
      return "unset"
  }
}

export const getArrowDirectionBasedOnPosition = (
  position,
  arrow_color,
  type = "normal",
) => {
  const arrowSize = { top: 18, right: 18, bottom: 18, left: 18 }
  switch (position) {
    case POSITION_ENUM.BOTTOM:
      if (type === "narrow") {
        arrowSize.bottom = 18
        arrowSize.left = 8
        arrowSize.right = 8
      } else if (type === "large") {
        arrowSize.bottom = 22
        arrowSize.left = 22
        arrowSize.right = 22
      } else if (type === "small") {
        arrowSize.bottom = 12
        arrowSize.left = 12
        arrowSize.right = 12
      } else if (type === "wide") {
        arrowSize.bottom = 14
        arrowSize.left = 28
        arrowSize.right = 28
      }
      break
    case POSITION_ENUM.TOP:
      if (type === "narrow") {
        arrowSize.top = 18
        arrowSize.left = 8
        arrowSize.right = 8
      } else if (type === "large") {
        arrowSize.top = 22
        arrowSize.left = 22
        arrowSize.right = 22
      } else if (type === "small") {
        arrowSize.top = 12
        arrowSize.left = 12
        arrowSize.right = 12
      } else if (type === "wide") {
        arrowSize.top = 14
        arrowSize.left = 28
        arrowSize.right = 28
      }
      break
    case POSITION_ENUM.LEFT:
      if (type === "narrow") {
        arrowSize.left = 18
        arrowSize.top = 8
        arrowSize.bottom = 8
      } else if (type === "large") {
        arrowSize.left = 22
        arrowSize.top = 22
        arrowSize.bottom = 22
      } else if (type === "small") {
        arrowSize.left = 12
        arrowSize.top = 12
        arrowSize.bottom = 12
      } else if (type === "wide") {
        arrowSize.left = 14
        arrowSize.top = 28
        arrowSize.bottom = 28
      }
      break
    case POSITION_ENUM.RIGHT:
      if (type === "narrow") {
        arrowSize.right = 18
        arrowSize.top = 8
        arrowSize.bottom = 8
      } else if (type === "large") {
        arrowSize.right = 22
        arrowSize.top = 22
        arrowSize.bottom = 22
      } else if (type === "small") {
        arrowSize.right = 12
        arrowSize.top = 12
        arrowSize.bottom = 12
      } else if (type === "wide") {
        arrowSize.right = 14
        arrowSize.top = 28
        arrowSize.bottom = 28
      }
      break
    default:
      break
  }
  switch (position) {
    case POSITION_ENUM.TOP:
      return {
        borderLeft: `${arrowSize.left}px solid transparent`,
        borderRight: `${arrowSize.right}px solid transparent`,
        borderTop: `${arrowSize.top}px solid ${arrow_color}`,
      }
    case POSITION_ENUM.LEFT:
      return {
        borderLeft: `${arrowSize.left}px solid ${arrow_color}`,
        borderTop: `${arrowSize.top}px solid transparent`,
        borderBottom: `${arrowSize.bottom}px solid transparent`,
      }
    case POSITION_ENUM.BOTTOM:
      return {
        borderLeft: `${arrowSize.left}px solid transparent`,
        borderRight: `${arrowSize.right}px solid transparent`,
        borderBottom: `${arrowSize.bottom}px solid ${arrow_color}`,
      }
    case POSITION_ENUM.RIGHT:
      return {
        borderRight: `${arrowSize.right}px solid ${arrow_color}`,
        borderTop: `${arrowSize.top}px solid transparent`,
        borderBottom: `${arrowSize.bottom}px solid transparent`,
      }
    default:
      return {
        borderLeft: `${arrowSize.left}px solid transparent`,
        borderRight: `${arrowSize.right}px solid transparent`,
        borderBottom: `${arrowSize.bottom}px solid black`,
      }
  }
}

export const getRoundArrowPosition = (position) => {
  switch (position) {
    case POSITION_ENUM.TOP:
      return { bottom: "60%" }
    case POSITION_ENUM.BOTTOM:
      return { top: "60%" }
    case POSITION_ENUM.RIGHT:
      return { left: "60%" }
    case POSITION_ENUM.LEFT:
      return { right: "60%" }
    default:
      return {}
  }
}

export const ORIENTATION_ENUM = {
  PORTRAIT: "portrait",
  LANDSCAPE: "landscape",
}

export const NO_OF_BUTTONS_IN_PIP = 2
export const BUTTONS_ARRAY_IN_PIP = MODAL_NEW_BUTTONS_ROW_NAMES.bottom

export const onModuleSelection = (
  dispatch,
  moduleName,
  prevModule,
  row_name = "",
) => {
  dispatch({
    type: SET_MODULE_TYPE,
    value: moduleName === prevModule ? "" : moduleName,
  })
  if (row_name !== "") {
    dispatch({
      type: SET_ROW_NAME,
      value: row_name,
    })
  }
  sendEvent(moduleName, { isExpanded: !(moduleName === prevModule) })
}

const buttonActions = {
  SET_TEXT: SET_BUTTON_TEXT,
  SET_COLOR: SET_BUTTON_COLOR,
  SET_FONT_FAMILY: SET_BUTTON_FONT_FAMILY,
  SET_FONT_SIZE: SET_BUTTON_FONT_SIZE,
  SET_ADAPTIVE_TEXT: SET_BUTTON_ADAPTIVE_TEXT,
  SET_FONT_STYLE: SET_BUTTON_FONT_STYLE,
  SET_IMAGE: SET_IMAGE,
  SET_BG_COLOR: SET_BUTTON_BG_COLOR,
  SET_BUTTON_PADDING: SET_BUTTON_PADDING,
  SET_BUTTON_MARGIN: SET_BUTTON_MARGIN,
  SET_BUTTON_TEXT_PADDING: SET_BUTTON_TEXT_PADDING,
  SET_BUTTON_TEXT_MARGIN: SET_BUTTON_TEXT_MARGIN,
  SET_DYNAMIC_TEXT_CONFIG: SET_BUTTON_DYNAMIC_TEXT_CONFIG,
}

const actionButtonActions = {
  ...buttonActions,
  SET_IMAGE: SET_BUTTON_IMAGE,
}

const textActions = {
  SET_COLOR: SET_COLOR,
  SET_FONT_FAMILY: SET_FONT_FAMILY,
  SET_FONT_SIZE: SET_FONT_SIZE,
  SET_ADAPTIVE_TEXT: SET_ADAPTIVE_TEXT,
  SET_FONT_STYLE: SET_FONT_STYLE,
  SET_TEXT_ALIGNMENT: SET_TEXT_ALIGNMENT,
  SET_TEXT: SET_TEXT,
  SET_DYNAMIC_TEXT_CONFIG: SET_DYNAMIC_TEXT_CONFIG,
  SET_ONBOARDING_TEXT_MARGIN: SET_ONBOARDING_TEXT_MARGIN,
  SET_ONBOARDING_TEXT_PADDING: SET_ONBOARDING_TEXT_PADDING,
}

const titleActions = {
  SET_COLOR: SET_COLOR,
  SET_FONT_FAMILY: SET_NEW_FONT_FAMILY,
  SET_FONT_SIZE: SET_NEW_FONT_SIZE,
  SET_ADAPTIVE_TEXT: SET_NEW_ADAPTIVE_TEXT,
  SET_FONT_STYLE: SET_NEW_FONT_STYLE,
  SET_FONT_WEIGHT: SET_NEW_FONT_WEIGHT,
  SET_TEXT_ALIGNMENT: SET_NEW_TEXT_ALIGNMENT,
  SET_DYNAMIC_TEXT_CONFIG: SET_DYNAMIC_TEXT_CONFIG,
  SET_TEXT: SET_TEXT,
}

const descriptionActions = {
  SET_COLOR: SET_COLOR,
  SET_FONT_FAMILY: SET_NEW_FONT_FAMILY,
  SET_FONT_SIZE: SET_NEW_FONT_SIZE,
  SET_ADAPTIVE_TEXT: SET_NEW_ADAPTIVE_TEXT,
  SET_FONT_STYLE: SET_NEW_FONT_STYLE,
  SET_FONT_WEIGHT: SET_NEW_FONT_WEIGHT,
  SET_TEXT_ALIGNMENT: SET_NEW_TEXT_ALIGNMENT,
  SET_DYNAMIC_TEXT_CONFIG: SET_DYNAMIC_TEXT_CONFIG,
  SET_TEXT: SET_TEXT,
  SET_SCROLLABLE: SET_SCROLLABLE,
  SET_SCROLLABLE_HEIGHT: SET_SCROLLABLE_HEIGHT,
  SET_SCROLLABLE_BORDER: SET_SCROLLABLE_BORDER,
  SET_SCROLLABLE_BORDER_WIDTH: SET_SCROLLABLE_BORDER_WIDTH,
  SET_SCROLLABLE_BORDER_COLOR: SET_SCROLLABLE_BORDER_COLOR,
  SET_SCROLLABLE_BORDER_STYLE: SET_SCROLLABLE_BORDER_STYLE,
  SET_SCROLLABLE_BORDER_RADIUS: SET_SCROLLABLE_BORDER_RADIUS,
}

const newButtonActions = {
  SET_NEW_BUTTON_BG_COLOR,
  SET_NEW_BUTTON_MARGIN,
  SET_NEW_BUTTON_PADDING,
  SET_NEW_BUTTON_BORDER_ENABLED,
  SET_NEW_BUTTON_ACTION_ENABLED,
  SET_NEW_BUTTON_BORDER_COLOR,
  SET_NEW_BUTTON_ACTION_TYPE,
  SET_NEW_BUTTON_REDIRECT_TYPE,
  SET_NEW_BUTTON_REDIRECT_URL,
  SET_NEW_BUTTON_BORDER_WIDTH,
  SET_NEW_BUTTON_BORDER_STYLE,
  SET_NEW_BUTTON_BORDER_RADIUS,
  SET_NEW_BUTTON_TOP_DIST,
  SET_NEW_BUTTON_LEFT_DIST,
  SET_NEW_BUTTON_TEXT,
  SET_NEW_BUTTON_TEXT_COLOR,
  SET_NEW_BUTTON_FONT_FAMILY,
  SET_NEW_BUTTON_FONT_SIZE,
  SET_NEW_BUTTON_FONT_STYLE,
}

const onBoardingActions = {
  SET_ONBOARDING_ANIM_TYPE: SET_ONBOARDING_ANIM_TYPE,
  SET_ONBOARDING_ANIM_DURATION: SET_ONBOARDING_ANIM_DURATION,
  SET_ONBOARDING_FADEOUT_OPACITY: SET_ONBOARDING_FADEOUT_OPACITY,
  SET_ONBOARDING_DISMISS_TYPE: SET_ONBOARDING_DISMISS_TYPE,
  SET_ONBOARDING_PAGINATION_TYPE: SET_ONBOARDING_PAGINATION_TYPE,
  SET_ONBOARDING_LEFT_PAD: SET_ONBOARDING_LEFT_PAD,
  SET_ONBOARDING_RIGHT_PAD: SET_ONBOARDING_RIGHT_PAD,
  SET_ONBOARDING_TOP_PAD: SET_ONBOARDING_TOP_PAD,
  SET_ONBOARDING_BOTTOM_PAD: SET_ONBOARDING_BOTTOM_PAD,
  SET_ONBOARDING_VERTICAL_MARGIN: SET_ONBOARDING_VERTICAL_MARGIN,
  SET_ONBOARDING_HORIZONTAL_MARGIN: SET_ONBOARDING_HORIZONTAL_MARGIN,
  SET_ONBOARDING_DOTS_ACTIVE_COLOR: SET_ONBOARDING_DOTS_ACTIVE_COLOR,
  SET_ONBOARDING_DOTS_BOTTOM_DIST: SET_ONBOARDING_DOTS_BOTTOM_DIST,
  SET_ONBOARDING_DOTS_INACTIVE_COLOR: SET_ONBOARDING_DOTS_INACTIVE_COLOR,
  SET_ONBOARDING_DOTS_OPACITY: SET_ONBOARDING_DOTS_OPACITY,
  SET_ONBOARDING_DOTS_RADIUS: SET_ONBOARDING_DOTS_RADIUS,
  SET_ONBOARDING_DOTS_DISTANCE: SET_ONBOARDING_DOTS_DISTANCE,
  SET_ONBOARDING_MESSAGE_POSITION: SET_ONBOARDING_MESSAGE_POSITION,
  SET_ONBOARDING_IMAGE_POSITION: SET_ONBOARDING_IMAGE_POSITION,
  SET_ONBOARDING_LAST_STEP_TEXT: SET_ONBOARDING_LAST_STEP_TEXT,
  SET_ONBOARDING_BTN_TEXT: SET_ONBOARDING_BTN_TEXT,
  SET_ONBOARDING_BTN_FONT_SIZE: SET_ONBOARDING_BTN_FONT_SIZE,
  SET_ONBOARDING_BTN_ADAPTIVE_TEXT: SET_ONBOARDING_BTN_ADAPTIVE_TEXT,
  SET_ONBOARDING_BTN_FONT_FAMILY: SET_ONBOARDING_BTN_FONT_FAMILY,
  SET_ONBOARDING_BTN_FONT_STYLE: SET_ONBOARDING_BTN_FONT_STYLE,
  SET_ONBOARDING_BTN_COLOR: SET_ONBOARDING_BTN_COLOR,
  SET_ONBOARDING_BTN_BACKGROUND_COLOR: SET_ONBOARDING_BTN_BACKGROUND_COLOR,
  SET_ONBOARDING_BACKGROUND_COLOR: SET_ONBOARDING_BACKGROUND_COLOR,
  SET_ONBOARDING_ACTION_BUTTON_MARGIN: SET_ONBOARDING_ACTION_BUTTON_MARGIN,
  SET_ONBOARDING_COUNTER_TEXT: SET_ONBOARDING_COUNTER_TEXT,
  SET_ONBOARDING_COUNTER_COLOR: SET_ONBOARDING_COUNTER_COLOR,
  SET_ONBOARDING_COUNTER_FONT_FAMILY: SET_ONBOARDING_COUNTER_FONT_FAMILY,
  SET_ONBOARDING_TEXT_MARGIN: SET_ONBOARDING_TEXT_MARGIN,
  SET_ONBOARDING_TEXT_PADDING: SET_ONBOARDING_TEXT_PADDING,
  SET_ONBOARDING_COUNTER_TEXT_SIZE: SET_ONBOARDING_COUNTER_TEXT_SIZE,
  SET_ONBOARDING_COUNTER_FONT_STYLE: SET_ONBOARDING_COUNTER_FONT_STYLE,
  SET_ONBOARDING_COUNTER_LEFT_DISTANCE: SET_ONBOARDING_COUNTER_LEFT_DISTANCE,
  SET_ONBOARDING_COUNTER_BOTTOM_DISTANCE:
    SET_ONBOARDING_COUNTER_BOTTOM_DISTANCE,
  SET_ONBOARDING_DIVIDER_COLOR: SET_ONBOARDING_DIVIDER_COLOR,
  SET_ONBOARDING_DIVIDER_ENABLED: SET_ONBOARDING_DIVIDER_ENABLED,
  SET_ONBOARDING_DISMISS_ACTION: SET_ONBOARDING_DISMISS_ACTION,
  SET_ONBOARDING_DIVIDER_HEIGHT: SET_ONBOARDING_DIVIDER_HEIGHT,
  SET_ONBOARDING_DIVIDER_MARGIN: SET_ONBOARDING_DIVIDER_MARGIN,
  SET_ONBOARDING_TOOLTIP_MARGIN: SET_ONBOARDING_TOOLTIP_MARGIN,
  SET_ONBOARDING_BORDER_COLOR: SET_ONBOARDING_BORDER_COLOR,
  SET_ONBOARDING_BORDER_WIDTH: SET_ONBOARDING_BORDER_WIDTH,
  SET_ONBOARDING_CORNER_WIDTH: SET_ONBOARDING_CORNER_WIDTH,
  SET_ONBOARDING_SKIP_RIGHT: SET_ONBOARDING_SKIP_RIGHT,
  SET_ONBOARDING_SKIP_TOP: SET_ONBOARDING_SKIP_TOP,
  SET_ONBOARDING_PREV_NEXT_DIST: SET_ONBOARDING_PREV_NEXT_DIST,
}

const newButtonTextActions = {
  SET_TEXT: SET_NEW_BUTTON_TEXT,
  SET_COLOR: SET_NEW_BUTTON_TEXT_COLOR,
  SET_PADDING: SET_NEW_BUTTON_TEXT_PADDING,
  SET_MARGIN: SET_NEW_BUTTON_TEXT_MARGIN,
  SET_FONT_FAMILY: SET_NEW_BUTTON_FONT_FAMILY,
  SET_FONT_SIZE: SET_NEW_BUTTON_FONT_SIZE,
  SET_ADAPTIVE_TEXT: SET_NEW_BUTTON_ADAPTIVE_TEXT,
  SET_FONT_STYLE: SET_NEW_BUTTON_FONT_STYLE,
  SET_FONT_WEIGHT: SET_NEW_BUTTON_FONT_WEIGHT,
  SET_DYNAMIC_TEXT_CONFIG: SET_NEW_BUTTON_DYNAMIC_TEXT,
}

const newCoachmarkBackGroundActions = {
  NEW_CONFIG_SET_BACKGROUND_COLOR,
  NEW_CONFIG_SET_BACKGROUND_OPACITY,
  NEW_CONFIG_SET_BACKGROUND_OFFSET,
  NEW_CONFIG_BACKGROUND_COACHMARK_DELTA_CIRCLE,
  NEW_CONFIG_BACKGROUND_COACHMARK_DELTA_RECT,
  SET_NEW_CONFIG_COACHMARK_ENABLE_RIPPLE,
  SET_NEW_CONFIG_COACHMARK_RIPPLE_OPACITY,
  SET_NEW_CONFIG_COACHMARK_RIPPLE_COLOR,
  SET_NEW_CONFIG_COACHMARK_RIPPLE_TYPE,
  SET_NEW_CONFIG_COACHMARK_RIPPLE_DURATION,
  SET_NEW_CONFIG_COACHMARK_RIPPLE_WIDTH,
}

export const getDataForModuleType = (ui, moduleType, row_name, slot) => {
  const {
    action_class,
    layout_type,
    action_buttons_config = [],
    corners = { width: 0 },
    buttons_config = [],
    buttons = {},
    title_config,
    content,
    image: coachmark_image = NEW_COACHMARKS_IMAGE.image,
    enable_image = NEW_COACHMARKS_IMAGE.enable_image,
    enable_arrow = NEW_COACHMARKS_ARROW.enable_arrow,
    arrow: coachmark_arrow = NEW_COACHMARKS_ARROW.arrow,
    inner_highlighter,
    outer_highlighter: {
      color: bgColor = NEW_COACHMARKS_BACKGROUND.outer_highlighter.color,
      opacity: bgOpacity = NEW_COACHMARKS_BACKGROUND.outer_highlighter.opacity,
      offset: {
        x: OffsetX = NEW_COACHMARKS_BACKGROUND.outer_highlighter.offset.x,
        y: OffsetY = NEW_COACHMARKS_BACKGROUND.outer_highlighter.offset.y,
      },
      shape = NEW_COACHMARKS_BACKGROUND.outer_highlighter.shape,
      delta_circle = NEW_COACHMARKS_BACKGROUND.outer_highlighter.delta_circle,
      delta_rect: {
        left: delta_rect_left = NEW_COACHMARKS_BACKGROUND.outer_highlighter
          .delta_rect.left,
        right: delta_rect_right = NEW_COACHMARKS_BACKGROUND.outer_highlighter
          .delta_rect.right,
        top: delta_rect_top = NEW_COACHMARKS_BACKGROUND.outer_highlighter
          .delta_rect.top,
        bottom: delta_rect_bottom = NEW_COACHMARKS_BACKGROUND.outer_highlighter
          .delta_rect.bottom,
      },
    } = NEW_COACHMARKS_BACKGROUND.outer_highlighter,
    arrow: {
      type: arrow_type = ARROW_CONFIG.arrow.type,
      color: arrow_color = ARROW_CONFIG.arrow.color,
      enable_border: enabale_arrow_border = ARROW_CONFIG.arrow.enable_border,
      border: {
        width: arrow_border_width = ARROW_CONFIG.arrow.border.width,
        color: arrow_border_color = ARROW_CONFIG.arrow.border.color,
        style: arrow_border_style = ARROW_CONFIG.arrow.border.style,
        radius: arrow_border_radius = ARROW_CONFIG.arrow.border.radius,
      },
    } = ARROW_CONFIG.arrow,
    position = NEW_INLINE_POSITION_CONFIG.position,
    pos_offset = BACKGROUND_OFFSET_CONFIG.pos_offset,
    enable_shadow = SHADOW_CONFIG.enable_shadow,
    shadow = SHADOW_CONFIG.shadow,
    enable_border = BORDER_CONFIG.enable_border,
    border = BORDER_CONFIG.border,
    padding_config = PADDING_CONFIG,
    margin_config = MARGIN_CONFIG,
    padding = PADDING,
    margin = MARGIN,
    text_config,
    skip: defaultSkip = SKIP_BUTTON_STATE.skip,
    next: defaultNext = NEXT_BUTTON_STATE.next,
    prev: defaultPrev = PREV_BUTTON_STATE.prev,
    title = TITLE.title,
    description = DESCRIPTION.description,
    enable_scroll = SCROLL_CONFIG.enable_scroll,
    scroll = SCROLL_CONFIG.scroll,
    image = "",
    size = 33,
    bg_color,
    bg_image = "",
    border_radius,
    image_size = "",
    action_config = {},
    x_icon_color,
    carousal = INITIAL_ONBOARDING_STATE.carousal,
    counter = INITIAL_ONBOARDING_STATE.counter,
    mini_color,
    sound_icon_color,
    close_button: {
      path: close_btn_path = CLOSE_CONFIG.close_button.path,
      color: close_btn_color = CLOSE_CONFIG.close_button.color,
      fill_color: close_btn_fill_color = CLOSE_CONFIG.close_button.fill_color,
      shape: close_btn_shape = CLOSE_CONFIG.close_button.shape,
      type: close_btn_type = CLOSE_CONFIG.close_button.type,
      action: close_btn_action = CLOSE_CONFIG.close_button.action,
      width: close_btn_width = CLOSE_CONFIG.close_button.width,
      height: close_btn_height = CLOSE_CONFIG.close_button.height,
      offset_top: close_btn_offset_top = CLOSE_CONFIG.close_button.offset_top,
      offset_right: close_btn_offset_right = CLOSE_CONFIG.close_button
        .offset_right,
    } = CLOSE_CONFIG.close_button,
    highlighter,
    enable_ripple,
    ripple,
    icon = MEDIA_ICON_CONFIG.icon,
    image: media_image = MEDIA_IMAGE_CONFIG.image,
    video = MEDIA_VIDEO_CONFIG.video,
    pip_button: {
      path: pip_button_path = PIP_BUTTON_CONFIG.pip_button.path,
      color: pip_button_color = PIP_BUTTON_CONFIG.pip_button.color,
      fill_color: pip_button_fill_color = PIP_BUTTON_CONFIG.pip_button
        .fill_color,
      shape: pip_button_shape = PIP_BUTTON_CONFIG.pip_button.shape,
      type: pip_button_type = PIP_BUTTON_CONFIG.pip_button.type,
      width: pip_button_width = PIP_BUTTON_CONFIG.pip_button.width,
      height: pip_button_height = PIP_BUTTON_CONFIG.pip_button.height,
      offset_top: pip_button_offset_top = PIP_BUTTON_CONFIG.pip_button
        .offset_top,
      offset_left: pip_button_offset_left = PIP_BUTTON_CONFIG.pip_button
        .offset_left,
    } = PIP_BUTTON_CONFIG.pip_button,
    badge: {
      position: {
        offset: {
          x: badge_offset_x = BADGE_POSITION_CONFIG.position.offset.x,
          y: badge_offset_y = BADGE_POSITION_CONFIG.position.offset.y,
        } = INITIAL_BADGE_STATE.badge.position.offset,
      } = BADGE_POSITION_CONFIG.position,
      enable_background:
        badge_background_enable_background = BADGE_BACKGROUND_CONFIG.enable_background,
      background: {
        width: badge_background_width = BADGE_BACKGROUND_CONFIG.background
          .width,
        height: badge_background_height = BADGE_BACKGROUND_CONFIG.background
          .height,
        image: {
          path: badge_background_image_path = BADGE_BACKGROUND_CONFIG.background
            .image.path,
        },
        enable_image: badge_background_enable_image = BADGE_BACKGROUND_CONFIG
          .background.enable_image,

        shape: {
          type: badge_background_shape_type = BADGE_BACKGROUND_CONFIG.background
            .shape.type,
          color: badge_background_shape_color = BADGE_BACKGROUND_CONFIG
            .background.shape.color,
          enable_border:
            enable_badge_background_shape_border = BADGE_BACKGROUND_CONFIG
              .background.shape.enable_border,
          border: {
            corners:
              badge_background_shape_border_corners = BADGE_BACKGROUND_CONFIG
                .background.shape.border.corners,
            color: badge_background_shape_border_color = BADGE_BACKGROUND_CONFIG
              .background.shape.border.color,
            width: badge_background_shape_border_width = BADGE_BACKGROUND_CONFIG
              .background.shape.border.width,
          } = BADGE_BACKGROUND_CONFIG.background.shape.border,
        },
      } = BADGE_BACKGROUND_CONFIG.background,
      content: badge_content = [ONE_BADGE_VARIANT_CONFIG],
    } = INITIAL_BADGE_STATE.badge,
  } = ui

  let skip = defaultSkip
  let next = defaultNext
  let prev = defaultPrev

  if (buttons_config.length > 0) {
    const s = buttons_config.find((b) => b.action === "skip")
    if (s) skip = s
    const n = buttons_config.find((b) => b.action === "next")
    if (n) next = n
    const p = buttons_config.find((b) => b.action === "prev")
    if (p) prev = p
  }

  let config = null
  let keyName = ""
  let actions = null
  let buttonConfig = null

  switch (moduleType) {
    // New Button BG
    case MODULE_TYPES.NEW_BUTTON:
      // For carousel buttons, look up by both slot AND position
      if (buttons_config && buttons_config.length > 0) {
        const pos = row_name || "top"
        buttonConfig = buttons_config.find(
          (btn) => btn.slot === slot && btn.position === pos,
        )
      }
      // Fallback to non-carousel buttons
      if (!buttonConfig && buttons[row_name]) {
        buttonConfig = buttons[row_name].find((btn) => btn.slot === slot)
      }
      keyName = buttons[row_name] ? ["buttons", row_name] : ["buttons_config"]
      actions = newButtonActions
      break

    // New Button Text
    case MODULE_TYPES.NEW_BUTTON_TEXT: {
      let targetBtn
      // For carousel buttons, look up by both slot AND position
      if (buttons_config && buttons_config.length > 0) {
        const pos = row_name || "top"
        targetBtn = buttons_config.find(
          (btn) => btn.slot === slot && btn.position === pos,
        )
      }
      // Fallback to non-carousel buttons
      if (!targetBtn && buttons[row_name]) {
        targetBtn = buttons[row_name].find((btn) => btn.slot === slot)
      }
      if (targetBtn) {
        if (typeof targetBtn.text === "string") {
          // Construct config for flat schema V2
          config = {
            text: targetBtn.text,
            color: targetBtn.color,
            font: {
              family: targetBtn.font_family,
              size: targetBtn.size,
              style: targetBtn.font_style,
              weight: targetBtn.style,
            },
          }
        } else {
          config = targetBtn.text
        }
      }
      keyName = buttons[row_name] ? ["buttons", row_name] : ["buttons_config"]
      actions = newButtonTextActions
      break
    }

    // New Arrow Actions
    case MODULE_TYPES.ARROW:
      config = {
        enabale_arrow_border,
        arrow_color,
        arrow_type,
        border: {
          arrow_border_color,
          arrow_border_radius,
          arrow_border_style,
          arrow_border_width,
        },
      }
      break

    // Background
    case MODULE_TYPES.BACKGROUND:
      buttonConfig = {
        color: bg_color,
      }
      if (action_class === ACTION_CLASSES.TOOLTIP) {
        buttonConfig.border_radius = corners.width
        config = {
          pos_offset,
          msg_margins: carousal?.msg_margins ?? DEFAULT_MSG_MARGIN,
        }
      }
      if (
        action_class === ACTION_CLASSES.INAPP ||
        action_class === ACTION_CLASSES.INLINE
      ) {
        buttonConfig.border_radius = border_radius

        if (layout_type === INAPP_LAYOUT_TYPES.FULL_SCREEN_MODAL) {
          buttonConfig.color = "#"
        }

        config = {
          position,
          enable_border,
          border,
          enable_shadow,
          shadow,
          padding_config,
          padding,
          margin_config,
          margin,
          buttons,
          pos_offset,
          msg_margins: carousal?.msg_margins ?? DEFAULT_MSG_MARGIN,
        }
      }

      actions = {
        //positon Offset Action
        SET_BACKGROUND_POSITION_OFFSET_SKID:
          SET_BACKGROUND_POSITION_OFFSET_SKID,
        SET_BACKGROUND_POSITION_OFFSET_DISTANCE:
          SET_BACKGROUND_POSITION_OFFSET_DISTANCE,

        SET_BG_COLOR: SET_BACKGROUND_COLOR,
        SET_BORDER_RADIUS:
          action_class === ACTION_CLASSES.INAPP
            ? SET_BORDER_BOTTOM_RADIUS
            : SET_BORDER_RADIUS,

        // Shadow Actions
        SET_SHADOW_ENABLED: SET_SHADOW_ENABLED,
        SET_SHADOW_COLOR: SET_SHADOW_COLOR,
        SET_SHADOW_OFFSET_X: SET_SHADOW_OFFSET_X,
        SET_SHADOW_OFFSET_Y: SET_SHADOW_OFFSET_Y,
        SET_SHADOW_BLUR_RADIUS: SET_SHADOW_BLUR_RADIUS,
        SET_SHADOW_SPREAD_RADIUS: SET_SHADOW_SPREAD_RADIUS,

        //Background offset
        SET_BACKGROUND_OFFSET_DISTANCE: SET_BACKGROUND_OFFSET_DISTANCE,
        SET_BACKGROUND_OFFSET_SKID: SET_BACKGROUND_OFFSET_SKID,

        // Border Actions
        SET_NEW_BORDER_ENABLED: SET_NEW_BORDER_ENABLED,
        SET_NEW_BORDER_WIDTH: SET_NEW_BORDER_WIDTH,
        SET_NEW_BORDER_COLOR: SET_NEW_BORDER_COLOR,
        SET_NEW_BORDER_STYLE: SET_NEW_BORDER_STYLE,
        SET_NEW_BORDER_RADIUS: SET_NEW_BORDER_RADIUS,

        // Padding Actions
        SET_MODAL_PADDING_TOP: SET_MODAL_PADDING_TOP,
        SET_MODAL_PADDING_BOTTOM: SET_MODAL_PADDING_BOTTOM,
        SET_MODAL_PADDING_LEFT: SET_MODAL_PADDING_LEFT,
        SET_MODAL_PADDING_RIGHT: SET_MODAL_PADDING_RIGHT,

        // Margin Actions
        SET_MODAL_MARGIN_TOP: SET_MODAL_MARGIN_TOP,
        SET_MODAL_MARGIN_BOTTOM: SET_MODAL_MARGIN_BOTTOM,
        SET_MODAL_MARGIN_LEFT: SET_MODAL_MARGIN_LEFT,
        SET_MODAL_MARGIN_RIGHT: SET_MODAL_MARGIN_RIGHT,

        // Buttons Actions
        SET_BUTTON_PADDING: SET_BUTTON_PADDING,
        SET_BUTTON_MARGIN: SET_BUTTON_MARGIN,

        // Arrow Actions
        SET_ARROW_COLOR: SET_ARROW_COLOR,

        //onBoarding actions
        SET_ONBOARDING_TOOLTIP_MARGIN,
      }
      break

    // Old Title
    case MODULE_TYPES.TITLE:
      config = title_config
      keyName = "title_config"
      actions = textActions
      break

    // Old Description
    case MODULE_TYPES.DESCRIPTION:
      config = text_config
      keyName = "text_config"
      actions = textActions
      break

    // New Title
    case MODULE_TYPES.TITLE_TEXT:
      config = title
      keyName = "title"
      actions = titleActions
      break

    // New Description
    case MODULE_TYPES.DESCRIPTION_TEXT:
      config = { ...description, enable_scroll, scroll }
      keyName = "description"
      actions = descriptionActions
      break

    // Title Icon
    case MODULE_TYPES.TITLE_ICON:
      config = title
      keyName = ["title", "icon"]
      actions = {
        SET_TITLE_ICON_PATH: SET_TITLE_ICON_PATH,
        SET_TITLE_ICON_WIDTH: SET_TITLE_ICON_WIDTH,
        SET_TITLE_ICON_HEIGHT: SET_TITLE_ICON_HEIGHT,
        SET_TITLE_ICON_BORDER_ENABLED: SET_TITLE_ICON_BORDER_ENABLED,
        SET_TITLE_ICON_BORDER_WIDTH: SET_TITLE_ICON_BORDER_WIDTH,
        SET_TITLE_ICON_BORDER_COLOR: SET_TITLE_ICON_BORDER_COLOR,
        SET_TITLE_ICON_BORDER_RADIUS: SET_TITLE_ICON_BORDER_RADIUS,
        SET_TITLE_ICON_BORDER_STYLE: SET_TITLE_ICON_BORDER_STYLE,
      }
      break

    // Old Buttons and Button Texts
    case MODULE_TYPES.BUTTON:
    case MODULE_TYPES.BUTTON1:
    case MODULE_TYPES.BUTTON2:
    case MODULE_TYPES.BUTTON_TEXT:
    case MODULE_TYPES.BUTTON_TEXT1:
    case MODULE_TYPES.BUTTON_TEXT2:
      if (
        moduleType === MODULE_TYPES.BUTTON_TEXT1 ||
        moduleType === MODULE_TYPES.BUTTON1
      ) {
        buttonConfig = buttons_config[0]
      } else if (
        moduleType === MODULE_TYPES.BUTTON_TEXT2 ||
        moduleType === MODULE_TYPES.BUTTON2
      ) {
        buttonConfig = buttons_config[1]
      } else {
        buttonConfig = buttons[row_name]?.find((btn) => btn.slot === slot)
      }
      config = buttonConfig?.text_config
      keyName = [buttonConfig?.__id, "text_config"]
      actions = buttonActions
      break

    // Short Menu Button BGs
    case MODULE_TYPES.ACTION_BUTTON1:
    case MODULE_TYPES.ACTION_BUTTON2:
    case MODULE_TYPES.ACTION_BUTTON3:
      if (moduleType === MODULE_TYPES.ACTION_BUTTON1) {
        buttonConfig = action_buttons_config[0]
      } else if (moduleType === MODULE_TYPES.ACTION_BUTTON2) {
        buttonConfig = action_buttons_config[1]
      } else {
        buttonConfig = action_buttons_config[2]
      }
      actions = buttonActions
      break

    // Short Menu Button Texts
    case MODULE_TYPES.ACTION_BUTTON_1_TEXT:
    case MODULE_TYPES.ACTION_BUTTON_2_TEXT:
    case MODULE_TYPES.ACTION_BUTTON_3_TEXT:
      if (moduleType === MODULE_TYPES.ACTION_BUTTON_1_TEXT) {
        buttonConfig = action_buttons_config[0]
      } else if (moduleType === MODULE_TYPES.ACTION_BUTTON_2_TEXT) {
        buttonConfig = action_buttons_config[1]
      } else {
        buttonConfig = action_buttons_config[2]
      }
      config = buttonConfig?.text_config
      keyName = [buttonConfig?.__id, "text_config"]
      actions = actionButtonActions
      break

    // Short Menu Button Descriptions
    case MODULE_TYPES.ACTION_BUTTON_1_DESC:
    case MODULE_TYPES.ACTION_BUTTON_2_DESC:
    case MODULE_TYPES.ACTION_BUTTON_3_DESC:
      if (moduleType === MODULE_TYPES.ACTION_BUTTON_1_DESC) {
        buttonConfig = action_buttons_config[0]
      } else if (moduleType === MODULE_TYPES.ACTION_BUTTON_2_DESC) {
        buttonConfig = action_buttons_config[1]
      } else {
        buttonConfig = action_buttons_config[2]
      }
      config = buttonConfig?.description_config
      keyName = [buttonConfig?.__id, "description_config"]
      actions = actionButtonActions
      break

    // Short Menu Button Images
    case MODULE_TYPES.ACTION_BUTTON_1_IMAGE:
    case MODULE_TYPES.ACTION_BUTTON_2_IMAGE:
    case MODULE_TYPES.ACTION_BUTTON_3_IMAGE:
      if (moduleType === MODULE_TYPES.ACTION_BUTTON_1_IMAGE) {
        buttonConfig = action_buttons_config[0]
      } else if (moduleType === MODULE_TYPES.ACTION_BUTTON_2_IMAGE) {
        buttonConfig = action_buttons_config[1]
      } else {
        buttonConfig = action_buttons_config[2]
      }
      config = buttonConfig?.image
      keyName = buttonConfig?.__id
      actions = actionButtonActions
      break

    // Image and BG Image URLs
    case MODULE_TYPES.BG_IMAGE_URL:
    case MODULE_TYPES.IMAGE_URL:
      config = {
        image: image,
        image_size: image_size,
        bg_image: bg_image,
        action_config: action_config,
        size,
      }
      actions = {
        SET_IMAGE: SET_IMAGE,
        SET_BG_IMAGE: SET_BG_IMAGE,
        SET_BG_IMAGE_SIZE: SET_BG_IMAGE_SIZE,
        SET_IMAGE_SIZE: SET_IMAGE_SIZE,
      }
      break

    // Image
    case MODULE_TYPES.IMAGE:
      actions = {
        SET_IMAGE: SET_IMAGE,
        SET_TOOLTIP_IMAGE_TYPE: SET_TOOLTIP_IMAGE_TYPE,
        SET_TOOLTIP_IMAGE_URL: SET_TOOLTIP_IMAGE_URL,
      }
      break

    // Video InApp Buttons
    case MODULE_TYPES.VIDEO_BUTTON:
      config = {
        x_icon_color,
        mini_color,
        sound_icon_color,
      }
      actions = {
        SET_VIDEO_BUTTON_COLOR,
      }
      break

    // Close Icon
    case MODULE_TYPES.CLOSE_BUTTON:
      config = {
        close_btn_path,
        close_btn_color,
        close_btn_fill_color,
        close_btn_shape,
        close_btn_type,
        close_btn_action,
        close_btn_width,
        close_btn_height,
        close_btn_offset_top,
        close_btn_offset_right,
      }
      actions = {
        SET_CLOSE_BUTTON_COLOR,
        SET_CLOSE_BUTTON_PATH,
        SET_CLOSE_BUTTON_FILL_COLOR,
        SET_CLOSE_BUTTON_SHAPE,
        SET_CLOSE_BUTTON_TYPE,
        SET_CLOSE_BUTTON_ACTION,
        SET_CLOSE_BUTTON_WIDTH,
        SET_CLOSE_BUTTON_HEIGHT,
        SET_CLOSE_BUTTON_OFFSET_TOP,
        SET_CLOSE_BUTTON_OFFSET_RIGHT,
      }
      break

    // Element Highlighter
    case MODULE_TYPES.ELEMENT_HIGHLIGHTER:
      config = highlighter
      actions = {
        SET_ELEMENT_HIGHLIGHTER_SHAPE,
        SET_ELEMENT_HIGHLIGHTER_OFFSET_RADIUS,
        SET_ELEMENT_HIGHLIGHTER_BORDER_COLOR,
        SET_ELEMENT_HIGHLIGHTER_BORDER_WIDTH,
        SET_ELEMENT_HIGHLIGHTER_BORDER_OPACITY,
        SET_ELEMENT_HIGHLIGHTER_OFFSET_BOTTOM,
        SET_ELEMENT_HIGHLIGHTER_OFFSET_LEFT,
        SET_ELEMENT_HIGHLIGHTER_OFFSET_RIGHT,
        SET_ELEMENT_HIGHLIGHTER_OFFSET_TOP,
        SET_ELEMENT_HIGHLIGHTER_CORNER_RADIUS,
      }
      break

    // Media Icon
    case MODULE_TYPES.MEDIA_ICON:
      config = {
        icon,
      }
      actions = {
        SET_MEDIA_ICON_PATH,
        SET_MEDIA_ICON_WIDTH,
        SET_MEDIA_ICON_HEIGHT,
        SET_MEDIA_ICON_ALIGNMENT,
        SET_MEDIA_ICON_BORDER_ENABLED,
        SET_MEDIA_ICON_BORDER_WIDTH,
        SET_MEDIA_ICON_BORDER_COLOR,
        SET_MEDIA_ICON_BORDER_RADIUS,
        SET_MEDIA_ICON_BORDER_STYLE,
      }
      break

    // Media Image
    case MODULE_TYPES.MEDIA_IMAGE:
      config = {
        image: media_image,
      }
      actions = {
        SET_MEDIA_IMAGE_PATH,
        SET_MEDIA_IMAGE_WIDTH,
        SET_MEDIA_IMAGE_HEIGHT,
        SET_MEDIA_IMAGE_BORDER_COLOR,
        SET_MEDIA_IMAGE_BORDER_ENABLED,
        SET_MEDIA_IMAGE_BORDER_RADIUS,
        SET_MEDIA_IMAGE_BORDER_STYLE,
        SET_MEDIA_IMAGE_BORDER_WIDTH,
        SET_MEDIA_IMAGE_ACTION_ENABLED,
        SET_MEDIA_IMAGE_ACTION,
      }
      break

    // Media Video
    case MODULE_TYPES.MEDIA_VIDEO:
      config = {
        video,
        bg_color,
      }
      actions = {
        SET_MEDIA_VIDEO_PATH,
        SET_MEDIA_VIDEO_WIDTH,
        SET_MEDIA_VIDEO_HEIGHT,
        SET_MEDIA_VIDEO_BORDER_COLOR,
        SET_MEDIA_VIDEO_BORDER_ENABLED,
        SET_MEDIA_VIDEO_BORDER_RADIUS,
        SET_MEDIA_VIDEO_BORDER_STYLE,
        SET_MEDIA_VIDEO_BORDER_WIDTH,
        SET_MEDIA_VIDEO_EMBED_ENABLED,
        SET_MEDIA_VIDEO_EMBED_HTML,
        SET_MEDIA_VIDEO_AUDIO_ENABLED,
        SET_BACKGROUND_COLOR,
      }
      break

    case MODULE_TYPES.PIP_BUTTON:
      config = {
        pip_button_path,
        pip_button_color,
        pip_button_fill_color,
        pip_button_shape,
        pip_button_type,
        pip_button_width,
        pip_button_height,
        pip_button_offset_top,
        pip_button_offset_left,
      }
      actions = {
        SET_PIP_BUTTON_COLOR,
        SET_PIP_BUTTON_PATH,
        SET_PIP_BUTTON_FILL_COLOR,
        SET_PIP_BUTTON_SHAPE,
        SET_PIP_BUTTON_TYPE,
        SET_PIP_BUTTON_WIDTH,
        SET_PIP_BUTTON_HEIGHT,
        SET_PIP_BUTTON_OFFSET_TOP,
        SET_PIP_BUTTON_OFFSET_LEFT,
      }
      break

    // Badges
    case MODULE_TYPES.BADGE:
      config = {
        badge_offset_x,
        badge_offset_y,
        badge_background_shape_type,
        badge_background_enable_background,
        badge_background_shape_border_corners,
        badge_background_shape_border_width,
        badge_background_shape_border_color,
        enable_badge_background_shape_border,
        badge_background_shape_color,
        badge_background_width,
        badge_background_height,
        badge_background_enable_image,
        badge_background_image_path,
      }
      break

    case MODULE_TYPES.BADGE_LABEL:
      config = { badge_content }
      break

    case MODULE_TYPES.BADGE_ICON:
      config = { badge_content }
      break

    case MODULE_TYPES.EXPLAINER_ACTION_BUTTON_SKIP:
      config = {
        color: skip.color,
        bg_color: skip.bg_color,
        font_family: skip.font_family,
        text: skip.text,
        size: skip.size,
        style: skip.style,
        bottom_dist: skip.bottom_dist,
        left_dist: skip.left_dist,
        align_center: skip.align_center,
        top_dist: skip.top_dist,
        pos_top: skip.pos_top,
        border_radius: skip.border_radius,
        margins: skip.margins,
        actionType: "skip",
      }
      actions = onBoardingActions
      keyName = "skip"
      break

    case MODULE_TYPES.EXPLAINER_ACTION_BUTTON_NEXT:
      config = {
        color: next.color,
        bg_color: next.bg_color,
        font_family: next.font_family,
        text: next.text,
        size: next.size,
        style: next.style,
        bottom_dist: next.bottom_dist,
        left_dist: next.left_dist,
        align_center: next.align_center,
        top_dist: next.top_dist,
        pos_top: next.pos_top,
        border_radius: next.border_radius,
        margins: next.margins,
        actionType: "next",
      }
      actions = onBoardingActions
      keyName = "next"
      break

    case MODULE_TYPES.EXPLAINER_ACTION_BUTTON_PREV:
      config = {
        color: prev.color,
        bg_color: prev.bg_color,
        font_family: prev.font_family,
        text: prev.text,
        size: prev.size,
        style: prev.style,
        bottom_dist: prev.bottom_dist,
        left_dist: prev.left_dist,
        align_center: prev.align_center,
        top_dist: prev.top_dist,
        pos_top: prev.pos_top,
        border_radius: prev.border_radius,
        margins: prev.margins,
        actionType: "prev",
      }
      actions = onBoardingActions
      keyName = "prev"
      break
    case MODULE_TYPES.EXPLAINER_TEXT:
      config = text_config
      keyName = "text_config"
      actions = textActions

      break
    case MODULE_TYPES.EXPLAINER_TITLE_TEXT:
      config = title_config
      keyName = "title_config"
      actions = textActions

      break
    case MODULE_TYPES.EXPLAINER_CAROUSEL_DOT:
      config = {
        d_type: carousal.d_type,
        m_temp: carousal.m_temp,
        d_pad: {
          bottom: carousal.d_pad.bottom,
          left: carousal.d_pad.left,
          right: carousal.d_pad.right,
          top: carousal.d_pad.top,
        },
        m_margin: { hz: carousal.m_margin.hz, vr: carousal.m_margin.vr },
        f_alpha: carousal.f_alpha,
        dots: carousal.dots,
        dots_dist: carousal.dots_dist,
        bottom_dist: carousal.bottom_dist,
        d_acolor: carousal.d_acolor,
        d_icolor: carousal.d_icolor,
        d_opacity: carousal.d_opacity,
        m_pos: carousal.m_pos,
        i_pos: carousal.i_pos,
        skip_top: carousal.skip_top,
        radius: carousal.radius,
      }
      actions = onBoardingActions
      break
    case MODULE_TYPES.EXPLAINER_CAROUSEL_COUNTER:
      config = {
        color: counter.color,
        font_family: counter.font_family,
        text: counter.text,
        size: counter.size,
        style: counter.style,
        bottom_dist: counter.bottom_dist,
        left_dist: counter.left_dist,
      }
      actions = onBoardingActions
      break
    case MODULE_TYPES.EXPLAINER_CAROUSEL_DIVIDER:
      config = carousal
      actions = onBoardingActions
      break
    case MODULE_TYPES.EXPLAINER_ELEMENT:
      config = carousal
      actions = onBoardingActions
      break
    case MODULE_TYPES.EXPLAINER_BACKGROUND:
      config = carousal
      actions = onBoardingActions
      break
    case MODULE_TYPES.NEW_COACHMARK_BACKGROUND:
      config = {
        bgColor,
        bgOpacity,
        OffsetX,
        OffsetY,
        shape,
        delta_circle,
        delta_rect_left,
        delta_rect_right,
        delta_rect_bottom,
        delta_rect_top,
        enable_ripple,
        ripple,
      }
      actions = newCoachmarkBackGroundActions
      break

    case MODULE_TYPES.NEW_COACHMARK_ELEMENT:
      config = inner_highlighter
      actions = {
        SET_NEW_CONFIG_ELEMENT_HIGHLIGHTER_SHAPE,
        SET_NEW_CONFIG_ELEMENT_HIGHLIGHTER_BORDER_RADIUS,
        SET_NEW_CONFIG_ELEMENT_HIGHLIGHTER_BORDER_COLOR,
        SET_NEW_CONFIG_ELEMENT_HIGHLIGHTER_BORDER_ENABLE,
        SET_NEW_CONFIG_ELEMENT_HIGHLIGHTER_BORDER_WIDTH,
        SET_NEW_CONFIG_ELEMENT_HIGHLIGHTER_BORDER_OPACITY,
        SET_NEW_CONFIG_ELEMENT_HIGHLIGHTER_BORDER_STYLE,
        NEW_CONFIG_ELEMENT_HIGHLIGHTER_DELTA_CIRCLE,
        NEW_CONFIG_ELEMENT_HIGHLIGHTER_DELTA_RECT,
      }
      break
    case MODULE_TYPES.NEW_COACHMARK_CONTENT:
      config = { content }
      actions = {
        SET_NEW_CONFIG_CONTENT_HEIGHT,
        SET_NEW_CONFIG_CONTENT_WIDTH,
        SET_NEW_CONFIG_CONTENT_MARGIN,
        SET_NEW_CONFIG_CONTENT_OFFSET,
        SET_NEW_CONFIG_CONTENT_POSITION,
        SET_NEW_CONFIG_CONTENT_ENABLE_TITLE,
        SET_NEW_CONFIG_CONTENT_ENABLE_DESC,
      }
      break
    case MODULE_TYPES.NEW_COACHMARK_IMAGE:
      config = { enable_image, coachmark_image }
      actions = {
        SET_NEW_CONFIG_COACHMARK_IMAGE_BORDER_PROPERTY,
        SET_NEW_CONFIG_COACHMARK_IMAGE_DIMENSION,
        SET_NEW_CONFIG_COACHMARK_IMAGE_ENABLE_BORDER,
        SET_NEW_CONFIG_COACHMARK_IMAGE_PATH,
        SET_NEW_CONFIG_COACHMARK_IMAGE_POSITION,
        SET_NEW_CONFIG_COACHMARK_IMAGE_TYPE,
        SET_NEW_CONFIG_COACHMARK_IMAGE_ASPECT_RATIO,
        SET_NEW_CONFIG_COACHMARK_IMAGE_OFFSET,
      }
      break
    case MODULE_TYPES.NEW_COACHMARK_ARROW:
      config = { enable_arrow, coachmark_arrow }
      actions = {
        SET_NEW_CONFIG_COACHMARK_ARROW_BORDER_PROPERTY,
        SET_NEW_CONFIG_COACHMARK_ARROW_DIMENSION,
        SET_NEW_CONFIG_COACHMARK_ARROW_ENABLE_BORDER,
        SET_NEW_CONFIG_COACHMARK_ARROW_ANGLE,
        SET_NEW_CONFIG_COACHMARK_ARROW_PATH,
        SET_NEW_CONFIG_COACHMARK_ARROW_POSITION,
        SET_NEW_CONFIG_COACHMARK_ARROW_TYPE,
        SET_NEW_CONFIG_COACHMARK_ARROW_ASPECT_RATIO,
        SET_NEW_CONFIG_COACHMARK_ARROW_OFFSET,
      }
      break
    case MODULE_TYPES.NEW_COACHMARK_CONTENT_DESC:
      config = { content }
      actions = {
        SET_NEW_CONFIG_CONTENT_TEXT,
        SET_NEW_CONFIG_CONTENT_TEXT_ALIGNMENT,
        SET_NEW_DYNAMIC_TEXT_CONFIG,
        SET_NEW_CONFIG_CONTENT_TEXT_COLOR,
        SET_NEW_CONFIG_CONTENT_TEXT_FONT_PROPERTY,
        SET_NEW_CONFIG_CONTENT_TEXT_MARGIN,
        SET_NEW_CONFIG_CONTENT_TEXT_PADDING,
      }
      break
    case MODULE_TYPES.NEW_COACHMARK_CONTENT_TITLE:
      config = { content }
      actions = {
        SET_NEW_CONFIG_CONTENT_TEXT,
        SET_NEW_CONFIG_CONTENT_TEXT_ALIGNMENT,
        SET_NEW_DYNAMIC_TEXT_CONFIG,
        SET_NEW_CONFIG_CONTENT_TEXT_COLOR,
        SET_NEW_CONFIG_CONTENT_TEXT_FONT_PROPERTY,
        SET_NEW_CONFIG_CONTENT_TEXT_MARGIN,
        SET_NEW_CONFIG_CONTENT_TEXT_PADDING,
      }
      break
    case MODULE_TYPES.NEW_COACHMARK_BUTTON:
      config = { content }
      actions = {
        SET_NEW_CONFIG_CONTENT_TEXT,
        SET_NEW_CONFIG_CONTENT_TEXT_ALIGNMENT,
        SET_NEW_CONFIG_CONTENT_TEXT_COLOR,
        SET_NEW_CONFIG_CONTENT_TEXT_FONT_PROPERTY,
        SET_NEW_CONFIG_CONTENT_TEXT_MARGIN,
        SET_NEW_CONFIG_CONTENT_TEXT_PADDING,
      }
      break
    case MODULE_TYPES.NEW_COACHMARK_BUTTON_TEXT1:
    case MODULE_TYPES.NEW_COACHMARK_BUTTON_TEXT2:
      config = { content }
      actions = {
        SET_NEW_CONFIG_CONTENT_TEXT,
        SET_NEW_CONFIG_CONTENT_TEXT_ALIGNMENT,
        SET_NEW_CONFIG_CONTENT_TEXT_COLOR,
        SET_NEW_DYNAMIC_TEXT_CONFIG,
        SET_NEW_CONFIG_CONTENT_TEXT_FONT_PROPERTY,
        SET_NEW_CONFIG_CONTENT_TEXT_MARGIN,
        SET_NEW_CONFIG_CONTENT_TEXT_PADDING,
      }
      break
    case MODULE_TYPES.NEW_COACHMARK_BUTTON1:
    case MODULE_TYPES.NEW_COACHMARK_BUTTON2:
      config = { content }
      actions = {
        SET_NEW_CONFIG_CONTENT_BUTTON_BORDER_PROPERTY,
        SET_NEW_CONFIG_CONTENT_BUTTON_COLOR,
        SET_NEW_CONFIG_CONTENT_BUTTON_BORDER_ENABLED,
        SET_NEW_CONFIG_CONTENT_BUTTON_MARGIN,
        SET_NEW_CONFIG_CONTENT_BUTTON_PADDING,
        SET_NEW_CONFIG_CONTENT_BUTTON_ENABLE_ACTION,
        SET_NEW_CONFIG_CONTENT_BUTTON_ENABLE_ACTION_TYPE,
        SET_NEW_CONFIG_CONTENT_BUTTON_ENABLE_REDIRECT_TYPE,
        SET_NEW_CONFIG_CONTENT_BUTTON_ENABLE_REDIRECT_URL,
      }
      break
    default:
      break
  }

  return { config, keyName, actions, buttonConfig }
}
